export const termsData = {
  ar: [
    {
      title: "أولاً: الشروط والأحكام",
      content: [
        "تهدف منصة SNA العقارية إلى إنشاء منظومة عقارية رقمية متكاملة تجمع مختلف أطراف السوق العقاري، بما يشمل المشترين والبائعين والمستأجرين والوكلاء العقاريين والمطورين العقاريين والبنوك والجهات التمويلية، وذلك ضمن بيئة احترافية تعزز الشفافية والموثوقية والامتثال للأنظمة المعمول بها في المملكة العربية السعودية.",
        "ويُعد استخدام المنصة أو إنشاء حساب فيها أو الاستفادة من أي من خدماتها موافقة صريحة ونهائية وملزمة على جميع هذه الشروط والأحكام والسياسات والاتفاقيات المرتبطة بها.",
        "التعاريف:",
        "يقصد بالمصطلحات التالية المعاني الموضحة أمام كل منها ما لم يقتضِ السياق خلاف ذلك:",
        "المنصة / التطبيق: منصة SNA العقارية بجميع خدماتها الإلكترونية، والموقع الإلكتروني، وتطبيقات الأجهزة الذكية، والواجهات البرمجية التابعة لها.",
        "الشركة: شركة مسار الأمجاد المالكة والمشغلة لمنصة SNA العقارية.",
        "المستخدم: أي شخص طبيعي أو اعتباري يستخدم خدمات المنصة بأي صفة كانت.",
        "الوكيل العقاري: وسيط عقاري مرخص نظاماً وفق الأنظمة المعمول بها داخل المملكة.",
        "المطور العقاري: أي جهة أو شركة تقوم بتطوير أو تسويق مشاريع عقارية.",
        "الجهة التمويلية: بنك أو شركة تمويل أو جهة مرخصة تقدم خدمات التمويل العقاري.",
        "المحتوى: جميع البيانات أو الصور أو النصوص أو الفيديوهات أو الملفات أو الإعلانات المنشورة عبر المنصة.",
        "الهيئة: الهيئة العامة للعقار أو أي جهة تنظيمية أو حكومية ذات علاقة.",
        "نطاق الخدمات:",
        "تعمل المنصة كوسيط تقني ورقمي يتيح للمستخدمين عرض وتسويق وشراء وبيع وتأجير العقارات والخدمات المرتبطة بها.",
        "لا تُعد المنصة طرفاً مباشراً في العقود أو الاتفاقيات المبرمة بين المستخدمين، ما لم يُنص على خلاف ذلك صراحة.",
        "تشمل خدمات المنصة – على سبيل المثال لا الحصر – ما يلي:",
        "إدارة الإعلانات العقارية.",
        "خدمات التسويق العقاري.",
        "خدمات الربط مع الجهات التمويلية.",
        "خدمات العرض ثلاثي الأبعاد (3D).",
        "التقارير والتحليلات العقارية.",
        "خدمات التوثيق والتحقق.",
        "الخدمات التقنية المساندة للقطاع العقاري.",
        "الالتزام بالأنظمة والامتثال:",
        "يلتزم جميع مستخدمي المنصة بكافة الأنظمة واللوائح والتعليمات المعمول بها في المملكة العربية السعودية.",
        "يشمل ذلك – على سبيل المثال لا الحصر:",
        "أنظمة الهيئة العامة للعقار.",
        "نظام حماية البيانات الشخصية.",
        "نظام مكافحة الجرائم المعلوماتية.",
        "أنظمة التجارة الإلكترونية.",
        "أنظمة مكافحة الاحتيال وغسل الأموال.",
        "أنظمة الفوترة الإلكترونية والضرائب.",
        "متطلبات تراخيص فال والإعلانات العقارية.",
        "لا يجوز استخدام المنصة لأي نشاط غير مشروع أو مخالف للأنظمة أو الآداب العامة.",
        "يلتزم جميع المستخدمين بالتعاون مع أي متطلبات تنظيمية أو رقابية تصدر من الجهات المختصة.",
        "إنشاء الحساب والتحقق:",
        "يلتزم المستخدم بتقديم معلومات صحيحة ودقيقة ومحدثة عند التسجيل في المنصة.",
        "يحق للمنصة طلب أي مستندات أو بيانات للتحقق من هوية المستخدم أو صفته النظامية، بما في ذلك:",
        "الهوية الوطنية أو الإقامة.",
        "السجل التجاري.",
        "التراخيص المهنية.",
        "التفويضات أو الوكالات.",
        "مستندات الملكية.",
        "يتحمل المستخدم كامل المسؤولية عن صحة البيانات والمعلومات المقدمة.",
        "يحق للمنصة تعليق أو إيقاف أو رفض أي حساب غير مكتمل أو مخالف أو يشتبه في عدم نظاميته.",
        "استخدام المنصة:",
        "يلتزم المستخدم باستخدام المنصة بصورة مشروعة وبما لا يضر بالمنصة أو مستخدميها.",
        "يحظر على المستخدم:",
        "نشر بيانات أو إعلانات مضللة.",
        "انتحال شخصية أو صفة غير صحيحة.",
        "استخدام المنصة لأغراض احتيالية.",
        "نشر محتوى مخالف للأنظمة أو الآداب العامة.",
        "محاولة اختراق أو تعطيل أنظمة المنصة.",
        "استخدام برامج آلية أو روبوتات لجمع البيانات أو سحب المحتوى.",
        "يلتزم المستخدم بعدم إساءة استخدام خدمات المنصة أو استغلالها بصورة تؤثر على موثوقية أو استقرار الخدمة.",
        "الإعلانات والمحتوى:",
        "يتحمل المستخدم كامل المسؤولية عن أي محتوى أو إعلان يقوم بنشره عبر المنصة.",
        "يجب أن تكون جميع الإعلانات:",
        "صحيحة ودقيقة.",
        "محدثة.",
        "غير مضللة.",
        "متوافقة مع الأنظمة.",
        "لا يجوز الإعلان عن:",
        "عقارات غير مصرح بالإعلان عنها.",
        "عقارات محل نزاع غير مفصح عنه.",
        "عقارات مخالفة للأنظمة.",
        "أي محتوى احتيالي أو مضلل.",
        "يحق للمنصة إزالة أو تعديل أو تعليق أي إعلان مخالف دون إشعار مسبق.",
        "الرسوم والعمولات:",
        "تخضع بعض خدمات المنصة لرسوم أو عمولات وفق سياسة الرسوم والعمولات المعتمدة.",
        "يتم سداد الرسوم عبر وسائل الدفع الإلكترونية المعتمدة داخل المنصة.",
        "تلتزم المنصة بإصدار الفواتير الإلكترونية وفق متطلبات هيئة الزكاة والضريبة والجمارك.",
        "تحتفظ المنصة بحق تعديل الرسوم أو العمولات مستقبلاً مع إشعار المستخدمين قبل سريان التعديلات بمدة مناسبة.",
        "تُعد سياسة الرسوم والعمولات جزءاً لا يتجزأ من هذه الشروط والأحكام.",
        "حقوق الملكية الفكرية:",
        "جميع الحقوق المتعلقة بالمنصة ومحتوياتها مملوكة حصرياً لشركة مسار الأمجاد.",
        "يشمل ذلك:",
        "اسم SNA العقارية.",
        "الشعار والهوية البصرية.",
        "البرمجيات والأكواد.",
        "التصاميم والواجهات.",
        "قواعد البيانات.",
        "التقارير والتحليلات.",
        "المحتوى الرقمي.",
        "خدمات ونماذج 3D.",
        "يُحظر نسخ أو إعادة استخدام أو استغلال أي جزء من المنصة دون موافقة خطية مسبقة.",
        "تخضع حقوق الملكية الفكرية لسياسة مستقلة منشورة عبر المنصة.",
        "حماية البيانات والخصوصية:",
        "تلتزم المنصة بحماية البيانات الشخصية ومعالجتها وفق الأنظمة المعمول بها في المملكة العربية السعودية.",
        "يتم جمع البيانات واستخدامها ومعالجتها وفق سياسة الخصوصية المعتمدة.",
        "يوافق المستخدم على معالجة بياناته بالقدر اللازم لتقديم الخدمات وتحسينها.",
        "تُعد سياسة الخصوصية جزءاً لا يتجزأ من هذه الشروط والأحكام.",
        "الأمن السيبراني:",
        "تلتزم المنصة باتخاذ التدابير التقنية والتنظيمية المناسبة لحماية الأنظمة والبيانات.",
        "لا يجوز للمستخدم:",
        "محاولة اختراق الأنظمة.",
        "الوصول غير المصرح به.",
        "تعطيل خدمات المنصة.",
        "استخدام أدوات تقنية ضارة أو برامج خبيثة.",
        "تحتفظ المنصة بحق اتخاذ كافة الإجراءات النظامية تجاه أي نشاط تقني ضار أو احتيالي.",
        "حدود المسؤولية:",
        "تبذل المنصة جهوداً معقولة للتحقق من صحة المعلومات، إلا أنها لا تضمن دقة أو اكتمال جميع البيانات المنشورة.",
        "لا تتحمل المنصة المسؤولية عن:",
        "قرارات الشراء أو الاستثمار.",
        "العقود المبرمة بين الأطراف.",
        "تعثر المشاريع أو تأخرها.",
        "قرارات التمويل أو الرفض الائتماني.",
        "أي خسائر غير مباشرة أو تبعية.",
        "لا تُعد المعلومات أو التقارير أو المحتويات المنشورة عبر المنصة توصية استثمارية أو ضماناً للعائد أو القيمة المستقبلية للعقار.",
        "القوة القاهرة:",
        "لا يتحمل أي طرف المسؤولية عن أي تأخير أو إخفاق ناتج عن ظروف خارجة عن الإرادة، بما في ذلك:",
        "الكوارث الطبيعية.",
        "القرارات الحكومية.",
        "الأعطال التقنية الجسيمة.",
        "انقطاع خدمات الاتصالات.",
        "الهجمات السيبرانية.",
        "الظروف الطارئة الخارجة عن السيطرة المعقولة.",
        "السجلات الإلكترونية:",
        "يقر المستخدم بأن السجلات والرسائل والإشعارات الإلكترونية الصادرة عبر المنصة تُعد حجة معتبرة وملزمة متى تمت وفق الأنظمة المعمول بها.",
        "التعليق والإيقاف:",
        "يحق للمنصة تعليق أو إيقاف أو حذف أي حساب أو محتوى عند:",
        "مخالفة الشروط والأحكام.",
        "الاشتباه بوجود احتيال.",
        "ورود طلب من جهة مختصة.",
        "الإضرار بالمنصة أو المستخدمين أو سمعتها.",
        "تسوية النزاعات والتحكيم:",
        "تخضع هذه الشروط لأنظمة المملكة العربية السعودية.",
        "يسعى الطرفان أولاً إلى التسوية الودية لأي نزاع ينشأ بينهما.",
        "يجوز اللجوء إلى الوساطة أو التحكيم عبر المركز السعودي للتحكيم التجاري متى اتفق الطرفان على ذلك.",
        "تختص المحاكم السعودية بالنظر في أي نزاع ينشأ عن استخدام المنصة.",
        "تعد اللغة العربية المرجع الرسمي في حال وجود أي تعارض بين النسخ أو الترجمات.",
        "التعديلات والتحديثات:",
        "تحتفظ المنصة بحق تعديل أو تحديث هذه الشروط والأحكام أو أي من السياسات المرتبطة بها في أي وقت، ويتم إشعار المستخدمين بالتحديثات عبر المنصة أو البريد الإلكتروني أو الإشعارات الإلكترونية.",
        "الأحكام الختامية:",
        "تشكل هذه الشروط والأحكام الاتفاق الكامل بين المنصة والمستخدم.",
        "في حال بطلان أي بند أو عدم قابليته للتنفيذ، لا يؤثر ذلك على صحة باقي البنود.",
        "عدم ممارسة المنصة لأي حق لا يعد تنازلاً عنه.",
        "تستمر البنود المتعلقة بالخصوصية والملكية الفكرية والمسؤولية حتى بعد إنهاء العلاقة مع المستخدم.",
        "التواصل:",
        "للاستفسارات أو الشكاوى أو الطلبات القانونية، يمكن التواصل عبر القنوات الرسمية الموضحة داخل منصة SNA العقارية.",
      ],
    },
    {
      title: "ثانياً: سياسة الخصوصية",
      content: [
        "تلتزم SNA العقارية التزامها الكامل بحماية خصوصية المستخدمين والمحافظة على سرية البيانات الشخصية وفقاً للأنظمة واللوائح المعمول بها في المملكة العربية السعودية، بما في ذلك نظام حماية البيانات الشخصية ولوائحه التنفيذية.",
        "وتهدف هذه السياسة إلى توضيح آلية جمع البيانات الشخصية واستخدامها ومعالجتها ومشاركتها وحمايتها، إضافةً إلى توضيح حقوق المستخدم المتعلقة ببياناته الشخصية.",
        "ويُعد استخدام المنصة موافقة صريحة من المستخدم على ما ورد في هذه السياسة.",
        "التعاريف:",
        "لأغراض هذه السياسة يقصد بالمصطلحات التالية المعاني الموضحة أمام كل منها ما لم يقتضِ السياق خلاف ذلك:",
        "المنصة: منصة SNA العقارية بجميع خدماتها الإلكترونية والموقع الإلكتروني والتطبيقات والواجهات التقنية التابعة لها.",
        "البيانات الشخصية: كل بيان من شأنه أن يؤدي إلى معرفة المستخدم بشكل مباشر أو غير مباشر.",
        "المستخدم: أي شخص طبيعي أو اعتباري يستخدم خدمات المنصة.",
        "المعالجة: أي عملية تتم على البيانات الشخصية سواء بالجمع أو التخزين أو الاستخدام أو النقل أو المشاركة أو الحذف أو غير ذلك.",
        "الجهات الشريكة: الجهات التمويلية أو التقنية أو التشغيلية أو العقارية المرتبطة بتقديم خدمات المنصة.",
        "البيانات التي نقوم بجمعها:",
        "قد تقوم المنصة بجمع ومعالجة أنواع متعددة من البيانات، وتشمل – على سبيل المثال لا الحصر – ما يلي:",
        "بيانات التسجيل والحساب:",
        "الاسم الكامل.",
        "رقم الهوية الوطنية أو الإقامة.",
        "رقم الجوال.",
        "البريد الإلكتروني.",
        "كلمة المرور وبيانات التحقق.",
        "بيانات التوثيق المهني أو التجاري.",
        "بيانات العقارات والإعلانات:",
        "تفاصيل العقارات والوحدات.",
        "الصور والفيديوهات والمخططات.",
        "بيانات الملكية أو التفويض.",
        "معلومات الوسطاء والمطورين.",
        "محتوى الإعلانات والمراسلات المرتبطة بها.",
        "بيانات الاستخدام والتقنية:",
        "عنوان IP.",
        "نوع الجهاز والمتصفح.",
        "نظام التشغيل.",
        "أوقات وتواريخ الدخول.",
        "سجل التصفح داخل المنصة.",
        "تفضيلات البحث والاستخدام.",
        "بيانات الموقع الجغرافي:",
        "عند استخدام خدمات الخرائط أو البحث الجغرافي، قد يتم جمع بيانات الموقع الجغرافي بعد الحصول على موافقة المستخدم أو إذنه من خلال إعدادات الجهاز.",
        "بيانات التمويل العقاري:",
        "عند التقديم على خدمات التمويل أو الربط مع الجهات التمويلية:",
        "قيمة التمويل المطلوبة.",
        "الدخل التقريبي.",
        "الالتزامات المالية الأساسية.",
        "بيانات الأهلية التمويلية.",
        "أي معلومات إضافية يوافق المستخدم على مشاركتها.",
        "كيفية استخدام البيانات:",
        "تستخدم المنصة البيانات الشخصية للأغراض التالية:",
        "إنشاء الحسابات وإدارة المستخدمين.",
        "تقديم وتحسين الخدمات.",
        "التحقق من الهوية ومنع الاحتيال.",
        "عرض الإعلانات العقارية المناسبة.",
        "معالجة طلبات التمويل والربط مع الجهات التمويلية.",
        "التواصل مع المستخدمين وإرسال الإشعارات والتنبيهات.",
        "إصدار الفواتير الإلكترونية.",
        "تحليل الأداء وتحسين تجربة الاستخدام.",
        "تطوير الخدمات والخصائص المستقبلية.",
        "الامتثال للمتطلبات النظامية والتنظيمية.",
        "مشاركة البيانات:",
        "تلتزم المنصة بعدم بيع البيانات الشخصية أو تأجيرها أو مشاركتها مع أي طرف ثالث إلا في الحالات التالية:",
        "بموافقة المستخدم الصريحة.",
        "مع الجهات الحكومية أو القضائية المختصة عند وجود متطلبات نظامية أو أوامر ملزمة.",
        "مع الجهات الشريكة ومزودي الخدمات، ويشمل ذلك:",
        "البنوك والجهات التمويلية.",
        "شركات التحقق والتوثيق.",
        "مزودي الخدمات التقنية والاستضافة.",
        "الوكلاء أو المطورين المرتبطين بالخدمة المطلوبة.",
        "وذلك بالقدر اللازم فقط لتحقيق الغرض المرتبط بالخدمة.",
        "حماية البيانات وأمن المعلومات:",
        "تلتزم المنصة باتخاذ التدابير التقنية والتنظيمية المناسبة لحماية البيانات الشخصية، وتشمل – على سبيل المثال لا الحصر – ما يلي:",
        "استخدام تقنيات التشفير والحماية الإلكترونية.",
        "تقييد الوصول إلى البيانات للمخولين فقط.",
        "حماية الأنظمة من الوصول غير المصرح به.",
        "مراقبة الأنشطة المشبوهة ومحاولات الاختراق.",
        "الاحتفاظ بالبيانات داخل بيئات تقنية آمنة.",
        "تطبيق ضوابط الأمن السيبراني المناسبة لطبيعة النشاط.",
        "كما تسعى المنصة إلى استضافة البيانات داخل المملكة العربية السعودية متى كان ذلك متطلباً نظامياً أو تشغيلياً.",
        "ملفات تعريف الارتباط (Cookies):",
        "قد تستخدم المنصة ملفات تعريف الارتباط وتقنيات مشابهة بهدف:",
        "تحسين تجربة المستخدم.",
        "تحليل الأداء والاستخدام.",
        "تخصيص المحتوى والخدمات.",
        "حفظ تفضيلات المستخدم.",
        "ويجوز للمستخدم التحكم في إعدادات ملفات الارتباط من خلال إعدادات المتصفح الخاص به.",
        "حقوق المستخدم:",
        "يتمتع المستخدم بالحقوق التالية وفق الأنظمة المعمول بها:",
        "الحق في معرفة كيفية جمع بياناته واستخدامها.",
        "الحق في الوصول إلى بياناته الشخصية.",
        "الحق في طلب تصحيح أو تحديث البيانات.",
        "الحق في طلب حذف البيانات متى كان ذلك ممكناً نظاماً.",
        "الحق في سحب الموافقة على معالجة البيانات.",
        "الحق في الاعتراض على بعض أنواع المعالجة وفق ما تسمح به الأنظمة.",
        "الاحتفاظ بالبيانات:",
        "تحتفظ المنصة بالبيانات الشخصية للفترة اللازمة لتحقيق الأغراض التي جُمعت من أجلها، أو للمدة التي تقتضيها الأنظمة والتعليمات المعمول بها في المملكة العربية السعودية.",
        "ويجوز الاحتفاظ ببعض البيانات لفترات إضافية لأغراض:",
        "الامتثال النظامي.",
        "حماية الحقوق.",
        "تسوية النزاعات.",
        "مكافحة الاحتيال.",
        "حفظ السجلات النظامية والمالية.",
        "نقل البيانات:",
        "يجوز للمنصة نقل أو مشاركة البيانات داخل أو خارج المملكة العربية السعودية بما يتوافق مع الأنظمة والتعليمات المنظمة لنقل البيانات الشخصية، وبما يحقق مستوى مناسباً من الحماية والسرية.",
        "حدود المسؤولية:",
        "تبذل المنصة جهوداً معقولة لحماية البيانات الشخصية، إلا أنها لا تضمن عدم وقوع أي اختراقات أو هجمات إلكترونية خارجة عن نطاق السيطرة المعقولة.",
        "كما لا تتحمل المنصة أي مسؤولية عن إفشاء البيانات الناتج عن:",
        "استخدام المستخدم لوسائل غير آمنة.",
        "مشاركة بيانات الدخول مع الغير.",
        "الإهمال أو سوء الاستخدام من قبل المستخدم.",
        "أعطال أو اختراقات خارجة عن السيطرة المعقولة للمنصة.",
        "خصوصية القُصّر:",
        "لا تستهدف خدمات المنصة القُصّر دون السن النظامية، ويجب استخدام المنصة من قبل أشخاص يملكون الأهلية القانونية الكاملة.",
        "التعديلات على السياسة:",
        "تحتفظ المنصة بحق تعديل أو تحديث سياسة الخصوصية في أي وقت بما يتوافق مع:",
        "المتطلبات النظامية.",
        "التطورات التقنية.",
        "تحسين الخدمات.",
        "وسيتم إشعار المستخدمين بأي تحديثات جوهرية عبر المنصة أو البريد الإلكتروني أو الإشعارات الإلكترونية.",
        "العلاقة بالشروط والأحكام:",
        "تُعد سياسة الخصوصية هذه جزءاً لا يتجزأ من الشروط والأحكام العامة الخاصة بمنصة SNA العقارية.",
        "النظام الواجب التطبيق والاختصاص:",
        "تخضع هذه السياسة لأنظمة المملكة العربية السعودية، وتختص المحاكم السعودية بالنظر في أي نزاع ينشأ بشأنها، مع إمكانية اللجوء إلى الوسائل البديلة لتسوية النزاعات وفق ما يتم الاتفاق عليه.",
      ],
    },
    {
      title: "ثالثاً: سياسة حقوق الملكية الفكرية",
      content: [
        "تحرص منصة SNA العقارية على حماية جميع حقوق الملكية الفكرية المتعلقة بالمنصة ومحتوياتها وخدماتها وتقنياتها، وذلك وفقاً للأنظمة واللوائح المعمول بها في المملكة العربية السعودية والاتفاقيات الدولية ذات العلاقة.",
        "ويُعد استخدام المنصة موافقةً صريحة من المستخدم على الالتزام بجميع الأحكام الواردة في هذه السياسة.",
        "ملكية المنصة ومحتوياتها:",
        "جميع الحقوق المتعلقة بمنصة SNA العقارية محفوظة ومملوكة حصرياً لشركة مسار الأمجاد، ويشمل ذلك – على سبيل المثال لا الحصر – ما يلي:",
        "اسم المنصة والعلامة التجارية (SNA العقارية).",
        "الشعار والهوية البصرية.",
        "تصميم واجهات المستخدم وتجربة الاستخدام.",
        "البرمجيات والأكواد البرمجية وقواعد البيانات.",
        "النصوص والمحتوى التسويقي.",
        "التصاميم والرسومات والإنفوجرافيك.",
        "الصور والفيديوهات والمقاطع الترويجية.",
        "التقارير والتحليلات والمؤشرات العقارية.",
        "النماذج والعروض ثلاثية الأبعاد (3D).",
        "أي تطويرات أو تحديثات تقنية مستقبلية.",
        "ويُحظر استخدام أو نسخ أو تقليد أو إعادة إنتاج أي جزء من هذه العناصر دون موافقة خطية مسبقة من شركة مسار الأمجاد.",
        "محتوى المستخدمين:",
        "يحتفظ المستخدم بملكية المحتوى الذي يقوم برفعه أو نشره عبر المنصة، بما في ذلك:",
        "صور العقارات.",
        "الفيديوهات.",
        "الوصف العقاري.",
        "المخططات.",
        "الملفات والمستندات.",
        "يمنح المستخدم منصة SNA العقارية ترخيصاً غير حصري وقابلاً للاستخدام والعرض والنشر والتسويق لذلك المحتوى داخل المنصة والقنوات المرتبطة بها، وذلك لغرض تقديم الخدمات وتحسين تجربة المستخدم والتسويق للعقارات والخدمات المرتبطة بها.",
        "يقر المستخدم بأنه يملك كافة الحقوق النظامية اللازمة للمحتوى الذي يقوم برفعه أو نشره، ويتحمل كامل المسؤولية عن أي انتهاك لحقوق الغير.",
        "الاستخدامات المحظورة:",
        "يُحظر على أي مستخدم أو طرف ثالث القيام بأي من الأعمال التالية:",
        "نسخ أو إعادة نشر محتوى المنصة دون إذن.",
        "استخدام العلامة التجارية أو الشعار دون تصريح.",
        "سحب أو استخراج البيانات (Data Scraping).",
        "استخدام برامج أو روبوتات آلية لجمع البيانات أو المحتوى.",
        "إعادة استخدام المحتوى لأغراض تجارية دون موافقة.",
        "إعادة تدريب أو تطوير نماذج ذكاء اصطناعي اعتماداً على بيانات أو محتويات المنصة دون موافقة خطية مسبقة.",
        "تصوير أو إعادة توزيع المحتوى بطريقة تنتهك حقوق الملكية الفكرية.",
        "تقليد تصميم المنصة أو خدماتها أو هويتها البصرية بصورة مضللة.",
        "حقوق النماذج والعروض ثلاثية الأبعاد (3D):",
        "تُعد جميع النماذج والعروض ثلاثية الأبعاد والتصاميم الرقمية التي يتم إنتاجها أو تطويرها أو عرضها عبر منصة SNA العقارية محتوىً محمياً بموجب أنظمة الملكية الفكرية.",
        "لا يجوز نسخها أو تحميلها أو إعادة استخدامها أو تعديلها أو إعادة بيعها دون موافقة خطية مسبقة من المنصة ومالك المحتوى – متى كان ذلك منطبقاً.",
        "التقارير والبيانات والتحليلات:",
        "جميع التقارير العقارية، والتحليلات، والمؤشرات السوقية، والبيانات الإحصائية الصادرة عن المنصة تُعد ملكية فكرية خاصة بمنصة SNA العقارية.",
        "لا يجوز إعادة نشرها أو استخدامها تجارياً أو نسبها إلى أي جهة أخرى دون إذن كتابي مسبق.",
        "الإبلاغ عن انتهاك حقوق الملكية الفكرية:",
        "في حال اعتقاد أي شخص أو جهة بوجود محتوى منشور عبر المنصة ينتهك حقوق الملكية الفكرية الخاصة به، يمكنه التقدم بإشعار رسمي يتضمن:",
        "بيانات مقدم البلاغ.",
        "وصف الحق محل الانتهاك.",
        "رابط أو وصف المحتوى محل الاعتراض.",
        "ما يثبت ملكية الحق.",
        "يحق للمنصة اتخاذ ما تراه مناسباً، بما في ذلك إزالة المحتوى مؤقتاً أو نهائياً إلى حين التحقق من البلاغ.",
        "المسؤولية والتعويض:",
        "يتحمل المستخدم كامل المسؤولية القانونية عن أي محتوى أو مواد يقوم بنشرها عبر المنصة بما يخالف حقوق الملكية الفكرية للغير، ويلتزم بتعويض المنصة عن أي مطالبات أو أضرار أو خسائر أو مصاريف قانونية تنشأ نتيجة لذلك.",
        "التعديلات والتحديثات:",
        "تحتفظ منصة SNA العقارية بالحق في تعديل أو تحديث هذه السياسة في أي وقت بما يتوافق مع التطورات التنظيمية أو التقنية أو التشغيلية، ويتم إشعار المستخدمين بالتحديثات عبر المنصة أو البريد الإلكتروني أو الإشعارات الإلكترونية.",
        "العلاقة بالشروط والأحكام:",
        "تُعد سياسة حقوق الملكية الفكرية هذه جزءاً لا يتجزأ من الشروط والأحكام العامة الخاصة بمنصة SNA العقارية.",
        "النظام الواجب التطبيق والاختصاص:",
        "تخضع هذه السياسة لأنظمة المملكة العربية السعودية، وتختص المحاكم السعودية بالنظر في أي نزاع ينشأ بشأنها، مع جواز اللجوء إلى الوساطة أو التحكيم وفق ما يتم الاتفاق عليه.",
      ],
    },
    {
      title: "رابعاً: سياسة الرسوم والعمولات",
      main: "تحدد هذه السياسة الرسوم والعمولات وآليات السداد والاسترداد المتعلقة بالخدمات المقدمة عبر منصة SNA العقارية. ويُعد استخدام أي خدمة مدفوعة عبر المنصة موافقة صريحة وملزمة على جميع ما ورد في هذه السياسة، والتي تُعد جزءاً لا يتجزأ من الشروط والأحكام العامة للمنصة.",
      sections: [
        {
          subtitle: "أحكام عامة",
          items: [
            "جميع الرسوم والعمولات الواردة في هذه السياسة تحتسب بالريال السعودي وتشمل ضريبة القيمة المضافة بنسبة 15% ما لم يُنص على خلاف ذلك.",
            "تحتفظ المنصة بحق تعديل الرسوم أو العمولات أو الباقات مستقبلاً وفق متغيرات السوق أو المتطلبات التشغيلية، مع إشعار المستخدمين قبل تطبيق أي تعديل بمدة مناسبة.",
            "يتم سداد جميع الرسوم عبر بوابات الدفع الإلكترونية المعتمدة داخل المنصة.",
            "لا تُقبل أي تحويلات أو مدفوعات خارجية إلا بعد موافقة المنصة خطياً.",
            "تصدر المنصة فواتير إلكترونية متوافقة مع متطلبات هيئة الزكاة والضريبة والجمارك.",
            "يلتزم المستخدم بسداد أي رسوم أو عمولات مستحقة خلال المدد المحددة.",
            "في حال التأخر عن السداد، يحق للمنصة تعليق بعض الخدمات أو الحسابات إلى حين السداد.",
          ],
        },
        {
          subtitle: "رسوم الحسابات والتوثيق",
          items: [
            "الحساب الأساسي: مجاني لجميع الفئات (المشترين، البائعين، المستأجرين، الوسطاء العقاريين، المطورين العقاريين، البنوك والجهات التمويلية).",
            "التوثيق المهني والحسابات الموثقة: 99 ريال سعودي تدفع مرة واحدة للحساب الواحد.",
            "ويمنح الحساب الموثق: شارة (موثق)، أولوية ظهور، تعزيز الموثوقية داخل المنصة.",
          ],
        },
        {
          subtitle: "رسوم الوسطاء العقاريين والمستخدمين",
          items: [
            "إدراج العقارات — أول عقارين: مجاناً.",
            "إدراج العقارات — ابتداءً من العقار الثالث: 50 ريال سعودي لكل عقار.",
            "الإعلانات المميزة — 7 أيام: 80 ريال.",
            "الإعلانات المميزة — 15 يوماً: 150 ريال.",
            "الإعلانات المميزة — 30 يوماً: 250 ريال.",
            "العضوية المميزة للوسطاء: 499 ريال شهرياً.",
            "وتشمل العضوية المميزة: أولوية الظهور، شارة موثقة، تقارير أداء وتحليلات، إبراز الحساب في نتائج البحث.",
            "عمولة إتمام الصفقة: 0.5% من قيمة الصفقة، وتُخصم إلكترونياً عند إتمام عملية البيع أو التأجير عبر بوابة الدفع الخاصة بالمنصة.",
          ],
        },
        {
          subtitle: "رسوم المطورين العقاريين",
          items: [
            "تسجيل المشاريع: 2,000 ريال سعودي لكل مشروع (مرة واحدة).",
            "إدراج الوحدات العقارية: أول 20 وحدة ضمن رسوم المشروع، وبعد ذلك 20 ريال سعودي لكل وحدة إضافية.",
            "الباقة البرونزية: 5,000 ريال لمدة 3 أشهر — وتشمل الظهور في الصفحة الرئيسية.",
            "الباقة الفضية: 10,000 ريال لمدة 3 أشهر — وتشمل ظهوراً مميزاً، حملات بريدية، إشعارات للمستخدمين المهتمين.",
            "الباقة الذهبية: 20,000 ريال لمدة 6 أشهر — وتشمل حملات إعلانية موجهة، تقارير أداء، إبراز موسع داخل المنصة.",
            "عمولة المبيعات: 0.25% من قيمة البيع، وتُخصم إلكترونياً عند إتمام العملية.",
          ],
        },
        {
          subtitle: "رسوم البنوك والجهات التمويلية",
          items: [
            "رسوم التسجيل والربط التقني (API): 15,000 ريال سعودي تدفع مرة واحدة.",
            "الاشتراك السنوي: 25,000 ريال سعودي سنوياً.",
            "رسوم إحالة العملاء المؤهلين: 200 ريال سعودي لكل طلب تمويل مؤهل.",
            "ويقصد بالطلب المؤهل: الطلب الذي استوفى البيانات الأساسية، والتحقق من رقم الجوال، والحد الأدنى من متطلبات التقييم الأولي.",
            "عمولة نجاح التمويل: 0.5% من قيمة التمويل الموافق عليه وفق اتفاقية الشراكة المبرمة.",
          ],
        },
        {
          subtitle: "رسوم خدمات العرض ثلاثي الأبعاد (3D)",
          items: [
            "رفع عرض ثلاثي الأبعاد أو فيديو جاهز: مجاناً لمدة 30 يوماً، ثم 20 ريال سعودي شهرياً لكل عرض بعد انتهاء الفترة المجانية.",
            "إنشاء عرض بواسطة المنصة — شقة أو فيلا صغيرة (أقل من 300 متر): 800 ريال.",
            "إنشاء عرض بواسطة المنصة — فيلا كبيرة أو قصر (من 300 إلى 600 متر): 1,200 ريال.",
            "إنشاء عرض بواسطة المنصة — عقار تجاري أو مشروع متكامل (أكثر من 600 متر): 1,500 ريال.",
            "الاشتراك الشهري: 2,000 ريال ويشمل 5 عقارات.",
            "الاشتراك ربع السنوي: 5,500 ريال ويشمل 15 عقاراً.",
            "الاشتراك السنوي: 18,000 ريال ويشمل 50 عقاراً.",
            "نسبة النجاح الإضافية: 0.5% من قيمة الصفقة عند إتمام بيع أو تأجير لعقار تم إنشاء عرض 3D له بواسطة المنصة.",
          ],
        },
        {
          subtitle: "سياسة الإلغاء والاسترداد",
          items: [
            "الإعلانات: يمكن إلغاء الإعلان خلال 24 ساعة مع استرداد 50% من الرسوم، وبعد ذلك لا تُسترد الرسوم.",
            "الاشتراكات الشهرية والسنوية: غير قابلة للاسترداد بعد التفعيل.",
            "خدمات 3D: يحق للمستخدم استرداد كامل المبلغ في حال الإلغاء قبل بدء التصوير بمدة لا تقل عن 7 أيام.",
            "رسوم الربط البنكي وAPI: غير قابلة للاسترداد بعد التفعيل.",
          ],
        },
        {
          subtitle: "الغرامات والتأخر في السداد",
          items: [
            "في حال التأخر عن سداد الرسوم المستحقة تفرض المنصة غرامة تأخير 2% شهرياً من المبلغ المستحق بحد أقصى لا يتجاوز أصل المبلغ المستحق.",
            "يتم تطبيق ذلك بما لا يخالف الأنظمة المعمول بها في المملكة العربية السعودية.",
          ],
        },
        {
          subtitle: "التسوية المالية",
          items: [
            "تتم تسوية المستحقات المالية الخاصة بالمنصة بصورة أسبوعية أو وفق ما يتم الاتفاق عليه.",
            "يحق للمنصة حجز أو تعليق أي مبالغ مرتبطة بنزاعات أو شبهات احتيال حتى انتهاء التحقق.",
          ],
        },
        {
          subtitle: "العلاقة بالسياسات والتعديلات والاختصاص",
          items: [
            "تُعد سياسة الرسوم والعمولات هذه جزءاً لا يتجزأ من السياسات والأحكام العامة الخاصة بمنصة SNA العقارية.",
            "تحتفظ المنصة بحق تعديل أو تحديث هذه السياسة مستقبلاً بما يتوافق مع التطورات التشغيلية والمتطلبات النظامية وظروف السوق، مع إشعار المستخدمين بالتعديلات قبل تطبيقها بمدة مناسبة.",
            "تخضع هذه السياسة لأنظمة المملكة العربية السعودية، وتختص المحاكم السعودية بالنظر في أي نزاع ينشأ عنها.",
          ],
        },
      ],
    },
    {
      title: "خامساً: اتفاقية الوكلاء العقاريين",
      content: [
        "تنظم هذه الاتفاقية العلاقة بين منصة SNA العقارية، وبين الوكلاء والوسطاء العقاريين المرخصين الراغبين باستخدام المنصة لتسويق وعرض العقارات والتواصل مع العملاء.",
        "ويُعد تسجيل الوكيل أو استخدامه للمنصة موافقة صريحة ونهائية وملزمة على جميع أحكام هذه الاتفاقية، والتي تُعد جزءاً لا يتجزأ من السياسات والأحكام العامة الخاصة بالمنصة.",
        "الأهلية والتسجيل:",
        "يشترط أن يكون الوكيل العقاري مرخصاً نظاماً وحاصلاً على التراخيص اللازمة لممارسة النشاط العقاري داخل المملكة العربية السعودية، وملتزماً بمتطلبات الهيئة العامة للعقار.",
        "يلتزم الوكيل بتقديم:",
        "نسخة من الهوية الوطنية أو الإقامة.",
        "السجل التجاري (إن وجد).",
        "رخصة فال أو أي تراخيص مطلوبة.",
        "بيانات التواصل الرسمية.",
        "أي مستندات إضافية تطلبها المنصة.",
        "يحق للمنصة إجراء عمليات تحقق إلكترونية أو يدوية للتأكد من صحة المعلومات والوثائق المقدمة.",
        "يحق للمنصة منح الحساب صفة: موثق، أو قيد التحقق، أو غير موثق، وفقاً لنتائج التحقق.",
        "التزامات الوكيل العقاري:",
        "يلتزم الوكيل العقاري بما يلي:",
        "تقديم معلومات وإعلانات صحيحة ودقيقة ومحدثة.",
        "عدم نشر أي إعلان مضلل أو غير نظامي.",
        "الالتزام بجميع الأنظمة والتعليمات العقارية المعمول بها.",
        "المحافظة على سرية بيانات العملاء وعدم إساءة استخدامها.",
        "عدم استخدام المنصة في أي أعمال احتيالية أو غير مشروعة.",
        "الالتزام بأخلاقيات المهنة والمعايير المهنية المعمول بها.",
        "تحديث حالة العقارات المباعة أو المؤجرة أو غير المتاحة فوراً.",
        "متطلبات إدراج العقارات:",
        "يجب أن يتضمن كل إعلان عقاري – متى كان ذلك منطبقاً – ما يلي:",
        "وصف دقيق للعقار.",
        "الموقع الجغرافي.",
        "المساحة.",
        "السعر.",
        "الصور أو الفيديوهات.",
        "حالة العقار.",
        "بيانات الترخيص أو التفويض.",
        "أي معلومات جوهرية تؤثر على قرار العميل.",
        "يقر الوكيل بأن لديه الحق النظامي في الإعلان عن العقار ويرفق ما يثبت ذلك.",
        "في حال عدم ملكية الوكيل للعقار: يجب وجود تفويض أو وكالة أو تصريح نظامي يجيز له الإعلان والتسويق.",
        "لا يجوز إخفاء أي عيوب أو التزامات أو نزاعات جوهرية متعلقة بالعقار.",
        "التوثيق والتحقق:",
        "توفر المنصة خدمات التحقق والتوثيق للحسابات والإعلانات.",
        "قد يتم ربط بعض البيانات بالجهات الحكومية أو أنظمة التحقق المعتمدة متى كان ذلك متاحاً نظاماً أو تقنياً.",
        "يحق للمنصة تعليق أو إزالة أي إعلان إلى حين استكمال إجراءات التحقق.",
        "التواصل والتعاملات:",
        "يتم التواصل بين الأطراف من خلال الوسائل المتاحة داخل المنصة أو عبر وسائل التواصل المعتمدة.",
        "لا تتحمل المنصة مسؤولية الاتفاقات أو العقود المبرمة بين الأطراف خارج نطاق خدماتها التقنية.",
        "يلتزم الوكيل بالتعامل بمهنية وشفافية مع العملاء.",
        "يحق للمنصة الاحتفاظ بسجلات المراسلات أو العمليات لأغراض تنظيمية أو قانونية أو تشغيلية.",
        "الرسوم والعمولات:",
        "يلتزم الوكيل بسداد الرسوم والعمولات المستحقة وفق سياسة الرسوم والعمولات المعتمدة.",
        "قد تشمل الرسوم:",
        "رسوم الإعلانات.",
        "العضويات المهنية.",
        "خدمات التوثيق.",
        "الحملات التسويقية.",
        "عمولات الصفقات.",
        "تحتفظ المنصة بحق تعليق بعض الخدمات عند التأخر في السداد.",
        "الإعلانات والمحتوى المحظور:",
        "يحظر على الوكيل نشر أو مشاركة أي من المحتويات التالية:",
        "الإعلانات الوهمية.",
        "العقارات غير المصرح بها.",
        "البيانات أو الصور المضللة.",
        "المحتوى المخالف للأنظمة أو الآداب العامة.",
        "أي محتوى ينتهك حقوق الغير أو حقوق الملكية الفكرية.",
        "ويحق للمنصة إزالة أي محتوى مخالف دون إشعار مسبق.",
        "الملكية الفكرية والبيانات:",
        "يقر الوكيل بأن جميع الحقوق المتعلقة بالمنصة ومحتوياتها مملوكة لشركة مسار الأمجاد.",
        "لا يجوز نسخ أو إعادة استخدام بيانات المنصة أو محتوياتها دون موافقة خطية مسبقة.",
        "يلتزم الوكيل بعدم استخدام أدوات تقنية أو برامج آلية لسحب البيانات أو نسخ المحتوى.",
        "المسؤولية والتعويض:",
        "يتحمل الوكيل كامل المسؤولية القانونية عن:",
        "صحة الإعلانات.",
        "المستندات المقدمة.",
        "البيانات المنشورة.",
        "أي التزامات أو مطالبات تنشأ عن استخدامه للمنصة.",
        "يلتزم الوكيل بتعويض المنصة عن أي أضرار أو خسائر أو دعاوى أو مطالبات تنتج عن:",
        "مخالفة الأنظمة.",
        "تقديم بيانات مضللة.",
        "انتهاك حقوق الغير.",
        "إساءة استخدام المنصة.",
        "التعليق والإيقاف:",
        "يحق للمنصة تعليق أو إيقاف أو إنهاء حساب الوكيل في الحالات التالية:",
        "مخالفة هذه الاتفاقية.",
        "تقديم معلومات غير صحيحة.",
        "الاشتباه في وجود نشاط احتيالي.",
        "الإساءة للعملاء أو المنصة.",
        "مخالفة الأنظمة والتعليمات التنظيمية.",
        "ولا يترتب على ذلك أي مسؤولية على المنصة تجاه الوكيل.",
        "حدود مسؤولية المنصة:",
        "تعمل المنصة كوسيط تقني ولا تتحمل مسؤولية:",
        "إتمام الصفقات.",
        "صحة العقود بين الأطراف.",
        "النزاعات العقارية.",
        "تعثر أو إلغاء الصفقات.",
        "لا تضمن المنصة تحقيق أي مبيعات أو نتائج تسويقية محددة.",
        "القوة القاهرة:",
        "لا تتحمل المنصة أو الوكيل المسؤولية عن أي تأخير أو إخفاق ناتج عن ظروف خارجة عن الإرادة، بما في ذلك:",
        "الكوارث الطبيعية.",
        "الأعطال التقنية.",
        "الهجمات السيبرانية.",
        "القرارات الحكومية.",
        "انقطاع خدمات الاتصالات.",
        "العلاقة بالسياسات والأحكام:",
        "تُعد هذه الاتفاقية جزءاً لا يتجزأ من السياسات والأحكام العامة الخاصة بمنصة SNA العقارية.",
        "التعديلات والتحديثات:",
        "تحتفظ المنصة بحق تعديل أو تحديث هذه الاتفاقية في أي وقت بما يتوافق مع التطورات التشغيلية والأنظمة والتعليمات ومتطلبات السوق، وسيتم إشعار الوكلاء بالتعديلات عبر المنصة أو البريد الإلكتروني أو الإشعارات الإلكترونية.",
        "النظام الواجب التطبيق والاختصاص:",
        "تخضع هذه الاتفاقية لأنظمة المملكة العربية السعودية، وتختص المحاكم السعودية بالنظر في أي نزاع ينشأ عنها، مع جواز اللجوء إلى الوساطة أو التحكيم وفق ما يتم الاتفاق عليه بين الأطراف.",
      ],
    },
    {
      title: "سادساً: اتفاقية المطورين العقاريين",
      content: [
        "تنظم هذه الاتفاقية العلاقة بين منصة SNA العقارية، وبين المطورين العقاريين الراغبين باستخدام المنصة لتسويق وإدارة وعرض مشاريعهم العقارية داخل المملكة العربية السعودية.",
        "ويُعد تسجيل المطور العقاري أو استخدامه لأي من خدمات المنصة موافقة صريحة ونهائية وملزمة على جميع أحكام هذه الاتفاقية، والتي تُعد جزءاً لا يتجزأ من الشروط والأحكام العامة الخاصة بالمنصة.",
        "الأهلية والتسجيل:",
        "يشترط أن يكون المطور العقاري:",
        "مرخصاً نظاماً.",
        "حاصلاً على سجل تجاري ساري.",
        "مخولاً نظامياً بممارسة النشاط العقاري والتطوير العقاري داخل المملكة العربية السعودية.",
        "يلتزم المطور بتقديم المستندات والبيانات المطلوبة، ويشمل ذلك – على سبيل المثال لا الحصر:",
        "السجل التجاري.",
        "التراخيص النظامية.",
        "بيانات المشروع.",
        "بيانات الممثل المفوض.",
        "مستندات الملكية أو التطوير أو التعاقد.",
        "أي مستندات إضافية تطلبها المنصة.",
        "يحق للمنصة التحقق من صحة البيانات والمستندات قبل تفعيل حساب المطور أو المشروع.",
        "يحق للمنصة رفض أو تعليق أي مشروع أو حساب لا يستوفي متطلبات التحقق أو الامتثال.",
        "التزامات المطور العقاري:",
        "يلتزم المطور العقاري بما يلي:",
        "تقديم معلومات صحيحة ودقيقة ومحدثة عن المشاريع والوحدات العقارية.",
        "الالتزام بالأنظمة والتعليمات المعمول بها داخل المملكة العربية السعودية.",
        "الإفصاح الكامل عن: حالة المشروع، التراخيص، مراحل التنفيذ، المخاطر الجوهرية، وأي تغييرات مؤثرة على المشروع.",
        "تحديث حالة الوحدات والمشاريع بصورة مستمرة.",
        "عدم نشر أي معلومات مضللة أو مبالغ فيها.",
        "الالتزام بمعايير الشفافية والاحترافية في التعامل مع العملاء.",
        "متطلبات عرض المشاريع:",
        "يجب أن يتضمن كل مشروع أو إعلان – متى كان ذلك منطبقاً – ما يلي:",
        "وصف المشروع.",
        "الموقع.",
        "الأسعار.",
        "المساحات.",
        "المخططات.",
        "مراحل التنفيذ.",
        "تاريخ التسليم المتوقع.",
        "صور أو نماذج المشروع.",
        "الرسوم والخدمات المشتركة.",
        "بيانات الضمانات والصيانة.",
        "يلتزم المطور بالإفصاح عن أي: رهونات، نزاعات، قيود تنظيمية، تأخيرات متوقعة، أو تعديلات جوهرية في المشروع.",
        "في مشاريع البيع على الخارطة: يلتزم المطور بالامتثال للأنظمة والتعليمات الخاصة بذلك، والإفصاح عن شروط التعاقد والسداد والتسليم.",
        "خدمات التسويق والعرض:",
        "توفر المنصة خدمات تسويق وإبراز للمشاريع العقارية وفق الباقات المعتمدة.",
        "يحق للمطور الاستفادة من:",
        "الحملات الإعلانية.",
        "إبراز المشاريع.",
        "التقارير التحليلية.",
        "خدمات 3D.",
        "الحملات التسويقية الرقمية.",
        "لا تضمن المنصة تحقيق نتائج أو مبيعات محددة.",
        "خدمات العرض ثلاثي الأبعاد (3D):",
        "يجوز للمطور طلب خدمات العرض ثلاثي الأبعاد أو الفيديو الاحترافي عبر المنصة.",
        "تخضع هذه الخدمات للرسوم والشروط المحددة في سياسة الرسوم والعمولات وشروط خدمات 3D.",
        "يلتزم المطور بتقديم بيانات دقيقة وصحيحة لإنتاج النماذج والعروض الرقمية.",
        "لا تتحمل المنصة المسؤولية عن أي اختلافات ناتجة عن معلومات أو مخططات غير صحيحة مقدمة من المطور.",
        "الدفعات والرسوم والعمولات:",
        "يلتزم المطور بسداد جميع الرسوم والعمولات المستحقة وفق سياسة الرسوم والعمولات المعتمدة.",
        "قد تشمل الرسوم:",
        "رسوم تسجيل المشاريع.",
        "رسوم الوحدات العقارية.",
        "رسوم التسويق.",
        "رسوم الخدمات الرقمية.",
        "عمولات البيع.",
        "في حال إتمام عمليات بيع عبر المنصة: تستحق المنصة العمولة المحددة وفق السياسة المعتمدة.",
        "يحق للمنصة تعليق بعض الخدمات في حال التأخر في السداد.",
        "الضمانات والتسليم:",
        "يلتزم المطور بتحديد مواعيد التسليم المتوقعة بصورة واضحة.",
        "يتحمل المطور كامل المسؤولية عن:",
        "تنفيذ المشروع.",
        "جودة الأعمال.",
        "الالتزام بالمواصفات.",
        "أعمال الصيانة والضمانات.",
        "لا تتحمل المنصة أي مسؤولية عن:",
        "تأخر التسليم.",
        "تعثر المشاريع.",
        "العيوب الإنشائية.",
        "النزاعات التعاقدية بين المطور والعملاء.",
        "الملكية الفكرية والمحتوى:",
        "يحتفظ المطور بملكية المحتوى الخاص بمشاريعه.",
        "يمنح المطور المنصة ترخيصاً باستخدام وعرض وتسويق المحتوى والمشاريع عبر المنصة والقنوات المرتبطة بها.",
        "لا يجوز للمطور استخدام أو نسخ أو إعادة استغلال أي محتوى أو بيانات تخص المنصة دون موافقة خطية مسبقة.",
        "المسؤولية والتعويض:",
        "يتحمل المطور كامل المسؤولية القانونية عن:",
        "صحة البيانات.",
        "دقة الإعلانات.",
        "التراخيص.",
        "المعلومات المالية والفنية.",
        "أي التزامات تجاه العملاء أو الجهات التنظيمية.",
        "يلتزم المطور بتعويض المنصة عن أي خسائر أو مطالبات أو أضرار أو دعاوى تنتج عن:",
        "تقديم بيانات غير صحيحة.",
        "مخالفة الأنظمة.",
        "انتهاك حقوق الغير.",
        "الإخلال بالتزاماته التعاقدية.",
        "حدود مسؤولية المنصة:",
        "تعمل المنصة كوسيط تقني وتسويقي ولا تتحمل مسؤولية:",
        "تنفيذ المشاريع.",
        "التزامات المطور.",
        "النزاعات التعاقدية.",
        "نتائج الاستثمار أو المبيعات.",
        "لا تُعد المعلومات أو التقارير المنشورة عبر المنصة توصية استثمارية أو ضماناً للعوائد المستقبلية.",
        "الأمن السيبراني وحماية البيانات:",
        "تلتزم المنصة باتخاذ التدابير التقنية المناسبة لحماية الأنظمة والبيانات.",
        "يلتزم المطور بعدم:",
        "محاولة اختراق الأنظمة.",
        "استخدام أدوات لسحب البيانات.",
        "إساءة استخدام المعلومات أو بيانات العملاء.",
        "تخضع البيانات وسياسات المعالجة لسياسة الخصوصية المعتمدة.",
        "التعليق والإيقاف:",
        "يحق للمنصة تعليق أو إيقاف أو حذف حساب المطور أو أي مشروع في الحالات التالية:",
        "مخالفة الأنظمة.",
        "تقديم معلومات مضللة.",
        "وجود شبهات احتيالية.",
        "الإضرار بالمنصة أو المستخدمين.",
        "مخالفة هذه الاتفاقية أو السياسات المرتبطة بها.",
        "القوة القاهرة:",
        "لا يتحمل أي طرف المسؤولية عن أي تأخير أو إخفاق ناتج عن ظروف خارجة عن الإرادة، بما في ذلك:",
        "الكوارث الطبيعية.",
        "الأعطال التقنية.",
        "الهجمات السيبرانية.",
        "القرارات الحكومية.",
        "انقطاع خدمات الاتصالات.",
        "العلاقة بالشروط والأحكام:",
        "تُعد هذه الاتفاقية جزءاً لا يتجزأ من السياسات والأحكام العامة الخاصة بمنصة SNA العقارية.",
        "التعديلات والتحديثات:",
        "تحتفظ المنصة بحق تعديل أو تحديث هذه الاتفاقية مستقبلاً بما يتوافق مع التطورات التشغيلية والأنظمة والتعليمات ومتطلبات السوق، وسيتم إشعار المطورين بالتعديلات عبر المنصة أو البريد الإلكتروني أو الإشعارات الإلكترونية.",
        "النظام الواجب التطبيق والاختصاص:",
        "تخضع هذه الاتفاقية لأنظمة المملكة العربية السعودية، وتختص المحاكم السعودية بالنظر في أي نزاع ينشأ عنها، مع جواز اللجوء إلى الوساطة أو التحكيم وفق ما يتم الاتفاق عليه بين الأطراف.",
      ],
    },
    {
      title: "سابعاً: اتفاقية البنوك والجهات التمويلية",
      content: [
        "تنظم هذه الاتفاقية العلاقة بين منصة SNA العقارية، وبين البنوك والجهات التمويلية الراغبة بعرض أو تقديم أو تسويق برامج التمويل العقاري أو استقبال طلبات التمويل عبر المنصة.",
        "ويُعد استخدام الجهة التمويلية لخدمات المنصة أو الربط التقني معها موافقة صريحة ونهائية وملزمة على جميع أحكام هذه الاتفاقية، والتي تُعد جزءاً لا يتجزأ من السياسات والأحكام العامة الخاصة بمنصة SNA العقارية.",
        "الأهلية والتسجيل:",
        "يشترط أن تكون الجهة التمويلية:",
        "مرخصة نظاماً.",
        "خاضعة للجهات الرقابية المختصة داخل المملكة العربية السعودية.",
        "مخولة بتقديم خدمات التمويل العقاري أو المنتجات التمويلية ذات العلاقة.",
        "تلتزم الجهة التمويلية بتقديم:",
        "الترخيص النظامي.",
        "بيانات التواصل الرسمية.",
        "بيانات الممثل المفوض.",
        "المعلومات التقنية اللازمة للربط.",
        "أي مستندات إضافية تطلبها المنصة.",
        "يحق للمنصة إجراء عمليات تحقق أو مراجعة للبيانات والمستندات قبل تفعيل الخدمة أو الربط.",
        "نطاق الخدمات:",
        "تتيح المنصة للجهات التمويلية – وفق ما يتم الاتفاق عليه – الخدمات التالية:",
        "عرض المنتجات التمويلية.",
        "استقبال طلبات التمويل.",
        "الربط التقني عبر واجهات API.",
        "خدمات الإحالة.",
        "الحملات التسويقية المشتركة.",
        "خدمات التحليل والتقارير.",
        "لا تلتزم المنصة بمنح أي جهة تمويلية حصرية ما لم يتم الاتفاق خطياً على خلاف ذلك.",
        "مشاركة البيانات والخصوصية:",
        "لا يتم مشاركة بيانات المستخدمين مع الجهة التمويلية إلا بعد الحصول على موافقة صريحة من المستخدم.",
        "قد تشمل البيانات المشتركة – متى وافق المستخدم – ما يلي:",
        "الاسم.",
        "رقم الجوال.",
        "البريد الإلكتروني.",
        "مبلغ التمويل المطلوب.",
        "بيانات الدخل التقريبي.",
        "بيانات الأهلية الأولية.",
        "تلتزم الجهة التمويلية بما يلي:",
        "حماية البيانات الشخصية.",
        "عدم استخدام البيانات لغير الأغراض المحددة.",
        "الالتزام بنظام حماية البيانات الشخصية والأنظمة ذات العلاقة.",
        "عدم مشاركة البيانات مع أي طرف غير مصرح به.",
        "تُعد سياسة الخصوصية الخاصة بالمنصة جزءاً لا يتجزأ من هذه الاتفاقية.",
        "العروض التمويلية والإفصاح:",
        "تلتزم الجهة التمويلية بتقديم معلومات صحيحة ودقيقة ومحدثة عن المنتجات التمويلية.",
        "يجب أن تتضمن العروض التمويلية – متى كان ذلك منطبقاً – ما يلي:",
        "نسبة أو تكلفة التمويل السنوية.",
        "مدة التمويل.",
        "الرسوم الإدارية.",
        "شروط الأهلية.",
        "الضمانات المطلوبة.",
        "أي رسوم أو التزامات إضافية.",
        "يحظر نشر أي عروض مضللة أو غير دقيقة أو مخالفة للأنظمة.",
        "يحق للمنصة إزالة أو تعليق أي عرض مخالف دون إشعار مسبق.",
        "الاعتماد المبدئي والربط التقني:",
        "يجوز للجهة التمويلية تقديم خدمات الاعتماد المبدئي أو التقييم الأولي عبر المنصة أو من خلال الربط التقني.",
        "يُعد الاعتماد المبدئي مؤشراً أولياً فقط ولا يمثل موافقة نهائية على التمويل.",
        "لا تتحمل المنصة مسؤولية:",
        "قرارات الرفض أو القبول الائتماني.",
        "تقييم الجدارة الائتمانية.",
        "العقود التمويلية النهائية.",
        "يتم تحديد الجوانب التقنية الخاصة بالربط وفق الاتفاقيات الفنية بين الطرفين.",
        "الرسوم والعمولات:",
        "تخضع الخدمات المقدمة للجهات التمويلية للرسوم والعمولات المحددة في سياسة الرسوم والعمولات الخاصة بالمنصة.",
        "قد تشمل الرسوم:",
        "رسوم التسجيل.",
        "رسوم الربط التقني.",
        "الاشتراكات السنوية.",
        "رسوم الإحالات.",
        "عمولات التمويل الناجح.",
        "الحملات التسويقية.",
        "يتم تحديد بعض الرسوم أو العمولات الإضافية وفق اتفاقيات الشراكة المبرمة بين الطرفين.",
        "الامتثال والالتزامات النظامية:",
        "تلتزم الجهة التمويلية بجميع الأنظمة والتعليمات المعمول بها داخل المملكة العربية السعودية.",
        "تتحمل الجهة التمويلية المسؤولية الكاملة عن:",
        "الامتثال التنظيمي.",
        "التحقق الائتماني.",
        "سلامة العقود التمويلية.",
        "الالتزامات المالية والتنظيمية الخاصة بها.",
        "يحق للمنصة تعليق أو إيقاف مشاركة البيانات أو الخدمات في حال الاشتباه بأي: احتيال، أو مخالفة تنظيمية، أو اختراق أمني، أو إساءة استخدام.",
        "الأمن السيبراني وحماية الأنظمة:",
        "يلتزم الطرفان باتخاذ التدابير التقنية والتنظيمية المناسبة لحماية الأنظمة والبيانات.",
        "لا يجوز للجهة التمويلية:",
        "محاولة اختراق الأنظمة.",
        "استخدام أدوات لسحب البيانات.",
        "إساءة استخدام واجهات الربط التقني.",
        "مشاركة بيانات الوصول مع أطراف غير مصرح بها.",
        "يحق للمنصة إيقاف الربط أو تقييد الوصول في حال وجود مخاطر أمنية أو تقنية.",
        "الملكية الفكرية:",
        "تحتفظ منصة SNA العقارية بكافة حقوق الملكية الفكرية المتعلقة بالمنصة وتقنياتها ومحتوياتها.",
        "لا يجوز للجهة التمويلية استخدام:",
        "اسم المنصة.",
        "الشعار.",
        "الهوية البصرية.",
        "المحتوى أو البيانات.",
        "إلا وفق ما تسمح به المنصة أو اتفاقيات الشراكة المبرمة.",
        "حدود المسؤولية:",
        "تعمل المنصة كوسيط تقني ولا تتحمل مسؤولية:",
        "قرارات التمويل.",
        "العقود التمويلية.",
        "التقييمات الائتمانية.",
        "أي خسائر مالية أو استثمارية.",
        "لا تضمن المنصة: قبول طلبات التمويل، أو نتائج أو أعداد العملاء، أو تحقيق أي عوائد أو نتائج تسويقية محددة.",
        "المسؤولية والتعويض:",
        "تتحمل الجهة التمويلية كامل المسؤولية القانونية عن:",
        "المنتجات التمويلية.",
        "البيانات المنشورة.",
        "الامتثال التنظيمي.",
        "أي مخالفات أو مطالبات قانونية متعلقة بخدماتها.",
        "تلتزم الجهة التمويلية بتعويض المنصة عن أي خسائر أو مطالبات أو دعاوى تنتج عن:",
        "مخالفة الأنظمة.",
        "إساءة استخدام البيانات.",
        "تقديم معلومات مضللة.",
        "الإخلال بهذه الاتفاقية.",
        "التعليق والإيقاف:",
        "يحق للمنصة تعليق أو إيقاف أو إنهاء خدمات الجهة التمويلية في الحالات التالية:",
        "مخالفة الأنظمة أو التعليمات.",
        "وجود شبهات احتيال أو اختراق.",
        "تقديم معلومات مضللة.",
        "الإضرار بالمستخدمين أو المنصة.",
        "مخالفة هذه الاتفاقية أو السياسات المرتبطة بها.",
        "القوة القاهرة:",
        "لا يتحمل أي طرف المسؤولية عن أي تأخير أو إخفاق ناتج عن ظروف خارجة عن الإرادة، بما في ذلك:",
        "الكوارث الطبيعية.",
        "الأعطال التقنية.",
        "الهجمات السيبرانية.",
        "القرارات الحكومية.",
        "انقطاع خدمات الاتصالات.",
        "العلاقة بالشروط والأحكام:",
        "تُعد هذه الاتفاقية جزءاً لا يتجزأ من السياسات والأحكام العامة الخاصة بمنصة SNA العقارية.",
        "التعديلات والتحديثات:",
        "تحتفظ المنصة بحق تعديل أو تحديث هذه الاتفاقية بما يتوافق مع التطورات التشغيلية والمتطلبات النظامية والتطورات التقنية والتنظيمية، وسيتم إشعار الجهات التمويلية بالتحديثات عبر الوسائل الرسمية المعتمدة.",
        "النظام الواجب التطبيق والاختصاص:",
        "تخضع هذه الاتفاقية لأنظمة المملكة العربية السعودية، وتختص المحاكم السعودية بالنظر في أي نزاع ينشأ عنها، مع جواز اللجوء إلى الوساطة أو التحكيم وفق ما يتم الاتفاق عليه بين الأطراف.",
      ],
    },
    {
      title: "ثامناً: شروط وأحكام خدمات العرض ثلاثي الأبعاد (3D)",
      content: [
        "تنظم هذه الاتفاقية آلية استخدام خدمات العرض ثلاثي الأبعاد (3D) والفيديوهات الاحترافية المقدمة عبر منصة SNA العقارية، وتوضح الحقوق والالتزامات والمسؤوليات المتعلقة بالمستخدمين والملاك والوكلاء والمطورين العقاريين المستفيدين من هذه الخدمة.",
        "ويُعد طلب الخدمة أو استخدامها موافقة صريحة ونهائية وملزمة على جميع أحكام هذه الاتفاقية، والتي تُعد جزءاً لا يتجزأ من الشروط والأحكام العامة الخاصة بمنصة SNA العقارية.",
        "طبيعة الخدمة:",
        "توفر المنصة خدمات العرض ثلاثي الأبعاد والفيديوهات الاحترافية للعقارات بهدف:",
        "تحسين تجربة المستخدم.",
        "تعزيز جودة التسويق العقاري.",
        "تسهيل استعراض العقارات بصورة تفاعلية.",
        "دعم اتخاذ القرار المبدئي للمستخدمين.",
        "تشمل الخدمة – بحسب نوع الطلب – ما يلي:",
        "رفع عروض ثلاثية الأبعاد جاهزة.",
        "إنشاء نماذج 3D احترافية.",
        "تصوير فيديوهات احترافية للعقارات.",
        "الجولات الافتراضية.",
        "دمج العروض داخل صفحات العقارات والمشاريع.",
        "لا تُعد هذه الخدمة بديلاً عن المعاينة الفعلية للعقار أو الفحص الهندسي أو القانوني.",
        "شروط استخدام الخدمة:",
        "يلتزم المستخدم أو المالك أو المطور أو الوكيل بتقديم:",
        "معلومات صحيحة ودقيقة.",
        "صور ومخططات نظامية.",
        "بيانات تعكس الواقع الفعلي للعقار.",
        "يقر المستخدم بأن أي معلومات أو مخططات أو صور غير صحيحة قد تؤدي إلى:",
        "إيقاف الخدمة.",
        "إزالة العرض.",
        "تحميله المسؤولية القانونية الكاملة.",
        "يحق للمنصة رفض أو تعليق أي طلب خدمة لا يتوافق مع:",
        "الأنظمة.",
        "السياسات الداخلية.",
        "المعايير الفنية أو المهنية.",
        "مسؤولية المنصة:",
        "تقدم المنصة الخدمة وفق المعايير التقنية والفنية المتاحة وقت التنفيذ.",
        "لا تتحمل المنصة المسؤولية عن:",
        "أي اختلافات طفيفة بين العرض الرقمي والعقار الفعلي.",
        "قرارات الشراء أو الاستثمار المبنية على الخدمة.",
        "العيوب غير الظاهرة أو غير المفصح عنها.",
        "أي معلومات خاطئة مقدمة من المستخدم أو المطور أو الوكيل.",
        "لا تُعد العروض ثلاثية الأبعاد أو الفيديوهات:",
        "تقارير هندسية.",
        "ضمانات جودة.",
        "توثيقاً قانونياً للعقار.",
        "مسؤولية المستخدم والمطور والوكيل:",
        "يتحمل مقدم الطلب كامل المسؤولية عن:",
        "صحة البيانات.",
        "نظامية العقار.",
        "التصاريح والموافقات اللازمة للتصوير أو العرض.",
        "يلتزم المستخدم بعدم:",
        "استخدام الخدمة بصورة مضللة.",
        "تعديل المحتوى بطريقة تخل بالحقيقة.",
        "استخدام الخدمة بما يخالف الأنظمة أو حقوق الغير.",
        "يقر المستخدم بأن المنصة ليست مسؤولة عن أي التزامات تعاقدية أو مالية تنشأ نتيجة استخدام الخدمة.",
        "الرسوم والاشتراكات:",
        "تخضع خدمات 3D والفيديو للرسوم والاشتراكات المحددة في سياسة الرسوم والعمولات الخاصة بالمنصة.",
        "تشمل الرسوم – بحسب نوع الخدمة – ما يلي:",
        "رسوم التصوير والإنتاج.",
        "رسوم الاشتراكات.",
        "رسوم الترويج والعرض.",
        "رسوم الجولات الافتراضية.",
        "رسوم استمرارية النشر.",
        "يتم توضيح الرسوم للمستخدم قبل تنفيذ الخدمة والموافقة عليها إلكترونياً.",
        "نسبة النجاح الإضافية:",
        "في حال إتمام عملية بيع أو تأجير لعقار تم إنتاج عرض 3D أو فيديو احترافي له بواسطة المنصة: تستحق المنصة النسبة المحددة في سياسة الرسوم والعمولات.",
        "يوافق المستخدم على احتساب هذه النسبة عند تحقق الصفقة وفق سجلات المنصة أو الأنظمة المرتبطة بها.",
        "حقوق الملكية الفكرية:",
        "جميع ما يتم تنفيذه من قبل المنصة ويشمل ما يلي:",
        "التصاميم.",
        "النماذج ثلاثية الأبعاد.",
        "الفيديوهات.",
        "المعالجات البصرية.",
        "المؤثرات الرقمية.",
        "ملفات التصميم والإنتاج.",
        "تُعد حقوقاً فكرية محمية لصالح منصة SNA العقارية وشركة مسار الأمجاد ما لم يتم الاتفاق خطياً على خلاف ذلك.",
        "لا يجوز القيام بما يلي:",
        "نسخ المحتوى.",
        "إعادة بيعه.",
        "إعادة استخدامه.",
        "تعديله.",
        "نشره خارج المنصة.",
        "إلا بموافقة خطية مسبقة.",
        "مدة العرض والنشر:",
        "يتم عرض المحتوى لمدة محددة وفق الباقة أو الاشتراك المختار.",
        "يحق للمنصة إزالة أو إيقاف أي عرض:",
        "بعد انتهاء الاشتراك.",
        "عند مخالفة الأنظمة.",
        "عند وجود نزاعات أو شكاوى جوهرية.",
        "عند عدم سداد الرسوم المستحقة.",
        "الإلغاء والاسترداد:",
        "يحق للمستخدم طلب إلغاء الخدمة قبل بدء التنفيذ وفق سياسة الاسترداد المعتمدة.",
        "لا يحق للمستخدم طلب الإلغاء بعد قيام المنصة بالبدء في:",
        "التصوير.",
        "التصميم.",
        "الإنتاج.",
        "المعالجة الفنية.",
        "فلا يحق المطالبة باسترداد الرسوم إلا وفق ما تقرره المنصة أو الأنظمة المعمول بها.",
        "تخضع جميع طلبات الإلغاء والاسترداد لسياسة الرسوم والعمولات الخاصة بالمنصة.",
        "الأمن السيبراني وحماية البيانات:",
        "تلتزم المنصة باتخاذ التدابير التقنية المناسبة لحماية:",
        "الملفات.",
        "التصاميم.",
        "البيانات.",
        "المواد الرقمية.",
        "لا يجوز للمستخدم:",
        "محاولة اختراق الأنظمة.",
        "سحب الملفات التقنية.",
        "إساءة استخدام المحتوى أو الخدمات الرقمية.",
        "حدود المسؤولية:",
        "لا تتحمل المنصة أي مسؤولية عن:",
        "نتائج البيع أو التأجير.",
        "القيمة السوقية للعقار.",
        "دقة التقييمات المالية.",
        "قرارات الاستثمار أو التمويل.",
        "تبقى مسؤولية التحقق والمعاينة والفحص النهائي على المستخدم أو المشتري أو المستثمر.",
        "التعليق والإيقاف:",
        "يحق للمنصة تعليق أو إزالة أي عرض أو خدمة في الحالات التالية:",
        "مخالفة الأنظمة.",
        "إساءة استخدام الخدمة.",
        "تقديم بيانات مضللة.",
        "انتهاك حقوق الملكية الفكرية.",
        "عدم سداد الرسوم المستحقة.",
        "القوة القاهرة:",
        "لا يتحمل أي طرف المسؤولية عن أي تأخير أو إخفاق ناتج عن ظروف خارجة عن الإرادة، بما في ذلك:",
        "الكوارث الطبيعية.",
        "الأعطال التقنية.",
        "الهجمات السيبرانية.",
        "القرارات الحكومية.",
        "انقطاع خدمات الاتصالات.",
        "العلاقة بالسياسات والأحكام:",
        "تُعد هذه الاتفاقية جزءاً لا يتجزأ من الشروط والأحكام العامة الخاصة بمنصة SNA العقارية.",
        "التعديلات والتحديثات:",
        "تحتفظ المنصة بحق تعديل أو تحديث هذه الاتفاقية بما يتوافق مع التطورات التقنية والمتطلبات التشغيلية والأنظمة والتعليمات، وسيتم إشعار المستخدمين بالتحديثات عبر الوسائل الرسمية المعتمدة.",
        "النظام الواجب التطبيق والاختصاص:",
        "تخضع هذه الاتفاقية لأنظمة المملكة العربية السعودية، وتختص المحاكم السعودية بالنظر في أي نزاع ينشأ عنها، مع جواز اللجوء إلى الوساطة أو التحكيم وفق ما يتم الاتفاق عليه بين الأطراف.",
      ],
    },
    {
      title: "تاسعاً: الأحكام الختامية العامة النهائية",
      content: [
        "تشكل هذه الأحكام الختامية جزءاً أساسياً ومكملاً لجميع:",
        "السياسات والأحكام.",
        "الاتفاقيات.",
        "الملاحق التنظيمية.",
        "الخاصة بمنصة SNA العقارية المملوكة لشركة مسار الأمجاد، وتُطبق على جميع مستخدمي وخدمات المنصة دون استثناء.",
        "حجية الموافقة الإلكترونية:",
        "يقر المستخدم بأن:",
        "التسجيل في المنصة.",
        "استخدام الخدمات.",
        "النقر على زر الموافقة.",
        "إتمام العمليات الإلكترونية.",
        "يُعد موافقة إلكترونية نظامية ملزمة لكافة البنود والسياسات المرتبطة بالمنصة.",
        "تتمتع السجلات والرسائل والإشعارات الإلكترونية بالحجية النظامية وفق الأنظمة المعمول بها في المملكة العربية السعودية.",
        "اللغة المعتمدة:",
        "تُعد اللغة العربية هي اللغة الرسمية والمعتمدة لتفسير جميع:",
        "السياسات.",
        "الاتفاقيات.",
        "العقود.",
        "المراسلات النظامية.",
        "في حال وجود أي تعارض بين النسخة العربية وأي ترجمة أخرى: تكون الأولوية للنسخة العربية.",
        "استقلالية البنود:",
        "في حال بطلان أي بند، أو عدم نظامية أي حكم، أو عدم قابلية أي جزء للتنفيذ، فإن ذلك لا يؤثر على صحة ونفاذ باقي البنود والأحكام الأخرى.",
        "التنازل وعدم التنازل:",
        "عدم ممارسة المنصة لأي حق من حقوقها في أي وقت لا يُعد تنازلاً عن ذلك الحق.",
        "لا يجوز للمستخدم التنازل عن أي من حقوقه أو التزاماته المتعلقة باستخدام المنصة دون موافقة خطية مسبقة من المنصة.",
        "القوة القاهرة:",
        "لا يتحمل أي طرف المسؤولية عن أي تأخير أو إخفاق ناتج عن ظروف خارجة عن الإرادة، بما في ذلك – على سبيل المثال لا الحصر:",
        "الكوارث الطبيعية.",
        "الحرائق.",
        "الفيضانات.",
        "الحروب أو الاضطرابات.",
        "القرارات الحكومية.",
        "الأعطال التقنية الجسيمة.",
        "انقطاع خدمات الاتصالات أو الإنترنت.",
        "الهجمات السيبرانية.",
        "الأوبئة أو الظروف الطارئة.",
        "ويتم تعليق الالتزامات المتأثرة طوال مدة استمرار حالة القوة القاهرة بالقدر المتأثر فقط.",
        "الأمن السيبراني ومكافحة الاحتيال:",
        "تلتزم المنصة بتطبيق التدابير والإجراءات المناسبة لحماية:",
        "الأنظمة.",
        "البيانات.",
        "العمليات الإلكترونية.",
        "يلتزم المستخدم بعدم:",
        "محاولة اختراق الأنظمة.",
        "إساءة استخدام المنصة.",
        "استخدام أي أدوات أو برامج ضارة.",
        "التحايل أو الاحتيال أو التلاعب بالبيانات أو العمليات.",
        "يحق للمنصة اتخاذ كافة الإجراءات اللازمة بما في ذلك:",
        "تعليق الحسابات.",
        "إيقاف العمليات.",
        "إبلاغ الجهات المختصة.",
        "المطالبة بالتعويضات.",
        "تسوية النزاعات:",
        "يسعى الطرفان أولاً إلى حل أي نزاع ينشأ بصورة ودية خلال مدة معقولة.",
        "يجوز اللجوء إلى:",
        "الوساطة.",
        "التحكيم.",
        "المركز السعودي للتحكيم التجاري.",
        "وذلك وفق ما يتم الاتفاق عليه بين الأطراف، مع عدم الإخلال بحق التقاضي أمام الجهات القضائية المختصة داخل المملكة العربية السعودية.",
        "الاختصاص القضائي والنظام الواجب التطبيق:",
        "تخضع جميع السياسات والاتفاقيات والخدمات والتعاملات الخاصة بمنصة SNA العقارية لأنظمة المملكة العربية السعودية.",
        "تختص المحاكم السعودية بالنظر والفصل في أي نزاع ينشأ عن استخدام المنصة أو الخدمات المرتبطة بها.",
        "التعديلات والتحديثات:",
        "تحتفظ المنصة بحق تعديل أو تحديث الشروط والأحكام والسياسات والرسوم والاتفاقيات والخدمات في أي وقت بما يتوافق مع المتطلبات النظامية والتطورات التشغيلية والتطورات التقنية وظروف السوق.",
        "يتم إشعار المستخدمين بالتحديثات عبر:",
        "البريد الإلكتروني.",
        "الإشعارات داخل المنصة.",
        "الرسائل النصية.",
        "أي وسيلة إلكترونية تعتمدها المنصة.",
        "يُعد استمرار استخدام المنصة بعد التحديث موافقة على النسخة المعدلة.",
        "العلاقة بين الوثائق القانونية:",
        "تُعد الوثائق التالية أجزاء مترابطة ومتكاملة وتشكل معاً الإطار القانوني الكامل لمنصة SNA العقارية:",
        "السياسات والأحكام.",
        "سياسة الخصوصية.",
        "سياسة الملكية الفكرية.",
        "سياسة الرسوم والعمولات.",
        "اتفاقية الوكلاء العقاريين.",
        "اتفاقية المطورين العقاريين.",
        "اتفاقية البنوك والجهات التمويلية.",
        "شروط خدمات العرض ثلاثي الأبعاد (3D).",
        "أي سياسات أو ملاحق إضافية تعتمدها المنصة مستقبلاً.",
        "حقوق المنصة:",
        "تحتفظ منصة SNA العقارية بكافة الحقوق المتعلقة بما يلي:",
        "تشغيل المنصة وإدارتها.",
        "تطوير الخدمات.",
        "تعديل أو إيقاف الخدمات.",
        "حماية البيانات والأنظمة.",
        "حماية الملكية الفكرية.",
        "حماية سمعة المنصة ومستخدميها.",
        "اتخاذ الإجراءات النظامية اللازمة عند المخالفات.",
        "التواصل الرسمي:",
        "تكون جميع الإشعارات والمراسلات الرسمية بين المنصة والمستخدم عبر:",
        "البريد الإلكتروني المسجل.",
        "الإشعارات داخل التطبيق.",
        "الرسائل النصية.",
        "القنوات الرسمية المعتمدة من المنصة.",
        "ويُعد أي إشعار مرسل عبر تلك الوسائل منتجاً لآثاره النظامية متى تم إرساله وفق البيانات المسجلة لدى المستخدم.",
        "النفاذ وسريان الأحكام:",
        "تدخل هذه الأحكام والسياسات حيز النفاذ اعتباراً من تاريخ نشرها عبر منصة SNA العقارية، وتبقى سارية إلى حين تعديلها أو استبدالها من قبل المنصة وفقاً للأنظمة المعمول بها.",
      ],
    },
    {
      title: "عاشراً: الإقرار والموافقة الإلكترونية",
      content: [
        "الإقرار بالموافقة:",
        "يقر المستخدم ويوافق إقراراً نهائياً وملزماً بأنه عند:",
        "إنشاء حساب في منصة SNA العقارية.",
        "استخدام أي من خدمات المنصة.",
        "النقر على زر (موافق) أو (تسجيل) أو (متابعة).",
        "الاستفادة من أي خدمة أو ميزة إلكترونية داخل المنصة.",
        "فإن ذلك يُعد موافقة إلكترونية صريحة ونهائية وملزمة على جميع:",
        "الشروط والأحكام.",
        "السياسات.",
        "الاتفاقيات.",
        "الرسوم والعمولات.",
        "الملاحق التنظيمية.",
        "الخاصة بمنصة SNA العقارية.",
        "الإقرار بصحة البيانات:",
        "يقر المستخدم بأن جميع:",
        "البيانات.",
        "المعلومات.",
        "المستندات.",
        "التراخيص.",
        "التفويضات.",
        "المقدمة عبر المنصة صحيحة ودقيقة وحديثة، ويتحمل كامل المسؤولية النظامية والقانونية عن أي معلومات غير صحيحة أو مضللة أو مزورة.",
        "الإقرار بالأهلية النظامية:",
        "يقر المستخدم بأنه:",
        "يتمتع بالأهلية النظامية الكاملة.",
        "مخول نظاماً باستخدام المنصة.",
        "يملك الصلاحيات اللازمة لإبرام الالتزامات والاتفاقيات المرتبطة بالخدمات المستخدمة.",
        "وفي حال كان المستخدم يمثل جهة اعتبارية، فإنه يقر بامتلاكه الصلاحيات القانونية اللازمة للتصرف نيابة عنها وإرفاق ما يثبت ذلك.",
        "الإقرار بفهم المخاطر:",
        "يقر المستخدم بأنه يفهم ويستوعب أن:",
        "المنصة تعمل كوسيط تقني ورقمي.",
        "القرارات الاستثمارية أو العقارية أو التمويلية تبقى مسؤولية المستخدم.",
        "المعلومات المنشورة عبر المنصة لا تُعد ضماناً للعوائد أو الأسعار أو النتائج الاستثمارية.",
        "المعاينة والفحص والتحقق النهائي مسؤولية المستخدم.",
        "الإقرار بالامتثال للأنظمة:",
        "يقر المستخدم بالتزامه الكامل بجميع:",
        "الأنظمة.",
        "اللوائح.",
        "التعليمات.",
        "المتطلبات التنظيمية.",
        "المعمول بها داخل المملكة العربية السعودية والمتعلقة باستخدام المنصة أو النشاط العقاري أو التمويلي أو التقني.",
        "الإقرار بحماية الحساب:",
        "يقر المستخدم بأنه المسؤول الوحيد عن:",
        "بيانات الدخول.",
        "كلمات المرور.",
        "حماية حسابه.",
        "جميع العمليات المنفذة من خلال حسابه.",
        "ويلتزم بإشعار المنصة فور الاشتباه بأي استخدام غير مصرح به.",
        "الإقرار بالرسوم والعمولات:",
        "يقر المستخدم بأنه:",
        "اطلع على سياسة الرسوم والعمولات.",
        "فهم جميع الرسوم المطبقة.",
        "يوافق على سداد أي رسوم أو عمولات مستحقة نظير الخدمات المستخدمة.",
        "الإقرار بالخصوصية وحماية البيانات:",
        "يقر المستخدم بأنه:",
        "اطلع على سياسة الخصوصية.",
        "وافق على جمع ومعالجة بياناته وفق الأنظمة والسياسات المعتمدة.",
        "يوافق على مشاركة البيانات اللازمة مع الجهات المرتبطة بالخدمة عند الحاجة ووفق الأنظمة.",
        "الإقرار بالملكية الفكرية:",
        "يقر المستخدم بأن جميع:",
        "الحقوق.",
        "العلامات التجارية.",
        "الشعارات.",
        "البرمجيات.",
        "التصاميم.",
        "البيانات.",
        "المحتويات.",
        "الخاصة بمنصة SNA العقارية مملوكة لشركة مسار الأمجاد، ويلتزم بعدم انتهاك أي من حقوق الملكية الفكرية المرتبطة بالمنصة.",
        "حجية السجلات الإلكترونية:",
        "يقر المستخدم بأن:",
        "السجلات الإلكترونية.",
        "الرسائل.",
        "العقود الإلكترونية.",
        "الإشعارات.",
        "الموافقات الرقمية.",
        "الصادرة عبر المنصة تُعد حجة نظامية معتبرة وملزمة وفق الأنظمة المعمول بها في المملكة العربية السعودية.",
        "التعديلات والتحديثات:",
        "يقر المستخدم بحق المنصة في:",
        "تعديل الخدمات.",
        "تحديث السياسات.",
        "تعديل الرسوم.",
        "تطوير الأنظمة والخصائص.",
        "وذلك بما يتوافق مع المتطلبات التشغيلية والتنظيمية، مع إشعار المستخدمين عبر الوسائل المعتمدة.",
        "النظام الواجب التطبيق:",
        "يخضع هذا الإقرار وجميع ما يتعلق باستخدام منصة SNA العقارية لأنظمة المملكة العربية السعودية، وتختص المحاكم السعودية بالنظر في أي نزاع ينشأ بشأنه.",
        "النفاذ:",
        "يُعد هذا الإقرار نافذاً وملزماً اعتباراً من تاريخ موافقة المستخدم الإلكترونية أو استخدامه لأي من خدمات منصة SNA العقارية.",
      ],
    },
  ],
  en: [
    {
      title: "First: Terms and Conditions",
      content: [
        "SNA Real Estate Platform aims to establish a comprehensive digital real estate ecosystem that brings together various parties of the real estate market, including buyers, sellers, tenants, real estate agents, real estate developers, banks, and financing entities, within a professional environment that promotes transparency, reliability, and compliance with the regulations in force in the Kingdom of Saudi Arabia.",
        "Using the Platform, creating an account, or benefiting from any of its services constitutes an explicit, final, and binding consent to all these Terms and Conditions, Policies, and related Agreements.",
        "Definitions:",
        "The following terms shall have the meanings shown next to each unless the context requires otherwise:",
        "Platform / Application: SNA Real Estate Platform with all its electronic services, website, smart device applications, and related APIs.",
        "Company: Masar Al-Amjad Company, the owner and operator of SNA Real Estate Platform.",
        "User: Any natural or legal person using the Platform's services in any capacity.",
        "Real Estate Agent: A legally licensed real estate broker in accordance with the regulations in force in the Kingdom.",
        "Real Estate Developer: Any entity or company engaged in developing or marketing real estate projects.",
        "Financing Entity: A bank, financing company, or licensed entity providing real estate financing services.",
        "Content: All data, images, texts, videos, files, or advertisements published through the Platform.",
        "Authority: The General Authority for Real Estate or any relevant regulatory or governmental body.",
        "Scope of Services:",
        "The Platform acts as a technical and digital intermediary enabling users to list, market, buy, sell, and lease properties and related services.",
        "The Platform is not a direct party to contracts or agreements between users, unless explicitly stated otherwise.",
        "Platform services include – by way of example and not limitation – the following:",
        "Managing property listings.",
        "Real estate marketing services.",
        "Linking with financing entities.",
        "3D display services.",
        "Real estate reports and analytics.",
        "Documentation and verification services.",
        "Technical support services for the real estate sector.",
        "Compliance with Regulations:",
        "All Platform users must comply with all regulations, rules, and instructions in force in the Kingdom of Saudi Arabia.",
        "This includes – by way of example and not limitation:",
        "General Authority for Real Estate regulations.",
        "Personal Data Protection Law.",
        "Anti-Cybercrime Law.",
        "E-commerce regulations.",
        "Anti-fraud and anti-money laundering regulations.",
        "E-invoicing and tax regulations.",
        "FAL license and real estate advertising requirements.",
        "The Platform may not be used for any unlawful activity or activity contrary to regulations or public morals.",
        "All users must cooperate with any regulatory or supervisory requirements issued by the competent authorities.",
        "Account Creation and Verification:",
        "Users must provide accurate, precise, and up-to-date information upon registration on the Platform.",
        "The Platform may request any documents or data to verify the user's identity or legal capacity, including:",
        "National ID or Residency.",
        "Commercial registration.",
        "Professional licenses.",
        "Authorizations or powers of attorney.",
        "Ownership documents.",
        "The user bears full responsibility for the accuracy of the data and information provided.",
        "The Platform may suspend, stop, or reject any incomplete, violating, or suspected non-compliant account.",
        "Platform Usage:",
        "The user commits to using the Platform lawfully and in a manner that does not harm the Platform or its users.",
        "The user is prohibited from:",
        "Publishing misleading data or advertisements.",
        "Impersonating a person or false capacity.",
        "Using the Platform for fraudulent purposes.",
        "Publishing content contrary to regulations or public morals.",
        "Attempting to hack or disrupt the Platform's systems.",
        "Using automated software or bots to collect data or scrape content.",
        "The user commits to not misusing the Platform's services or exploiting them in a manner that affects the reliability or stability of the service.",
        "Advertisements and Content:",
        "The user bears full responsibility for any content or advertisement they publish through the Platform.",
        "All advertisements must be:",
        "Accurate and precise.",
        "Up to date.",
        "Non-misleading.",
        "Compliant with regulations.",
        "It is prohibited to advertise:",
        "Properties not authorized for advertising.",
        "Properties under undisclosed dispute.",
        "Properties violating regulations.",
        "Any fraudulent or misleading content.",
        "The Platform may remove, modify, or suspend any violating advertisement without prior notice.",
        "Fees and Commissions:",
        "Some Platform services are subject to fees or commissions in accordance with the approved Fees and Commissions Policy.",
        "Fees are paid through the approved electronic payment methods within the Platform.",
        "The Platform commits to issuing electronic invoices in accordance with ZATCA requirements.",
        "The Platform reserves the right to modify fees or commissions in the future with appropriate advance notice to users before the amendments take effect.",
        "The Fees and Commissions Policy is an integral part of these Terms and Conditions.",
        "Intellectual Property Rights:",
        "All rights related to the Platform and its contents are exclusively owned by Masar Al-Amjad Company.",
        "This includes:",
        "The name SNA Real Estate.",
        "The logo and visual identity.",
        "Software and codes.",
        "Designs and interfaces.",
        "Databases.",
        "Reports and analytics.",
        "Digital content.",
        "3D services and models.",
        "Copying, reusing, or exploiting any part of the Platform without prior written consent is prohibited.",
        "Intellectual property rights are subject to an independent policy published on the Platform.",
        "Data Protection and Privacy:",
        "The Platform commits to protecting and processing personal data in accordance with the regulations in force in the Kingdom of Saudi Arabia.",
        "Data is collected, used, and processed in accordance with the approved Privacy Policy.",
        "The user agrees to the processing of their data to the extent necessary to provide and improve services.",
        "The Privacy Policy is an integral part of these Terms and Conditions.",
        "Cybersecurity:",
        "The Platform commits to taking appropriate technical and organizational measures to protect systems and data.",
        "The user is not permitted to:",
        "Attempt to hack systems.",
        "Gain unauthorized access.",
        "Disrupt the Platform's services.",
        "Use harmful technical tools or malicious software.",
        "The Platform reserves the right to take all legal actions against any harmful or fraudulent technical activity.",
        "Limitation of Liability:",
        "The Platform makes reasonable efforts to verify information accuracy but does not guarantee the accuracy or completeness of all published data.",
        "The Platform is not liable for:",
        "Purchase or investment decisions.",
        "Contracts concluded between parties.",
        "Project delays or failures.",
        "Financing decisions or credit rejection.",
        "Any indirect or consequential losses.",
        "Information, reports, or content published through the Platform is not an investment recommendation or a guarantee of return or future property value.",
        "Force Majeure:",
        "No party bears responsibility for any delay or failure resulting from circumstances beyond control, including:",
        "Natural disasters.",
        "Governmental decisions.",
        "Major technical failures.",
        "Communication service outages.",
        "Cyberattacks.",
        "Emergency circumstances beyond reasonable control.",
        "Electronic Records:",
        "The user acknowledges that electronic records, messages, and notifications issued through the Platform constitute valid and binding evidence when made in accordance with applicable regulations.",
        "Suspension and Termination:",
        "The Platform may suspend, stop, or delete any account or content upon:",
        "Violation of the Terms and Conditions.",
        "Suspicion of fraud.",
        "A request from a competent authority.",
        "Harm to the Platform, its users, or its reputation.",
        "Dispute Resolution and Arbitration:",
        "These terms are governed by the laws of the Kingdom of Saudi Arabia.",
        "The parties first seek amicable resolution of any dispute arising between them.",
        "Mediation or arbitration through the Saudi Center for Commercial Arbitration may be pursued when the parties agree.",
        "Saudi courts have jurisdiction over any dispute arising from the use of the Platform.",
        "The Arabic language is the official reference in case of any conflict between versions or translations.",
        "Amendments and Updates:",
        "The Platform reserves the right to amend or update these Terms and Conditions or any related policies at any time, and users are notified of updates via the Platform, email, or electronic notifications.",
        "Final Provisions:",
        "These Terms and Conditions constitute the complete agreement between the Platform and the user.",
        "If any provision is invalid or unenforceable, this shall not affect the validity of the remaining provisions.",
        "The Platform's non-exercise of any right shall not constitute a waiver of it.",
        "Provisions related to privacy, intellectual property, and liability continue even after the relationship with the user ends.",
        "Contact:",
        "For inquiries, complaints, or legal requests, you may contact us through the official channels indicated within SNA Real Estate Platform.",
      ],
    },
    {
      title: "Second: Privacy Policy",
      content: [
        "SNA Real Estate is fully committed to protecting users' privacy and maintaining the confidentiality of personal data in accordance with the regulations and rules in force in the Kingdom of Saudi Arabia, including the Personal Data Protection Law and its implementing regulations.",
        "This Policy aims to clarify the mechanism for collecting, using, processing, sharing, and protecting personal data, in addition to clarifying the user's rights regarding their personal data.",
        "Using the Platform constitutes an explicit consent from the user to what is stated in this Policy.",
        "Definitions:",
        "For the purposes of this Policy, the following terms shall have the meanings shown next to each unless the context requires otherwise:",
        "Platform: SNA Real Estate Platform with all its electronic services, website, applications, and related technical interfaces.",
        "Personal Data: Any data that could lead to identifying the user directly or indirectly.",
        "User: Any natural or legal person using the Platform's services.",
        "Processing: Any operation performed on personal data, whether collecting, storing, using, transferring, sharing, deleting, or otherwise.",
        "Partner Entities: Financing, technical, operational, or real estate entities associated with providing the Platform's services.",
        "Data We Collect:",
        "The Platform may collect and process multiple types of data, including – by way of example and not limitation – the following:",
        "Registration and Account Data:",
        "Full name.",
        "National ID or Residency number.",
        "Mobile number.",
        "Email address.",
        "Password and verification data.",
        "Professional or commercial documentation data.",
        "Property and Advertisement Data:",
        "Property and unit details.",
        "Images, videos, and layouts.",
        "Ownership or authorization data.",
        "Agent and developer information.",
        "Advertisement content and related correspondence.",
        "Usage and Technical Data:",
        "IP address.",
        "Device and browser type.",
        "Operating system.",
        "Login times and dates.",
        "Browsing history within the Platform.",
        "Search and usage preferences.",
        "Geographic Location Data:",
        "When using maps or geographic search services, location data may be collected after obtaining the user's consent or permission through device settings.",
        "Real Estate Financing Data:",
        "When applying for financing services or linking with financing entities:",
        "Required financing amount.",
        "Approximate income.",
        "Basic financial obligations.",
        "Financing eligibility data.",
        "Any additional information the user agrees to share.",
        "How We Use Data:",
        "The Platform uses personal data for the following purposes:",
        "Creating accounts and managing users.",
        "Providing and improving services.",
        "Identity verification and fraud prevention.",
        "Displaying relevant property listings.",
        "Processing financing requests and linking with financing entities.",
        "Communicating with users and sending notifications and alerts.",
        "Issuing electronic invoices.",
        "Analyzing performance and improving user experience.",
        "Developing future services and features.",
        "Compliance with statutory and regulatory requirements.",
        "Data Sharing:",
        "The Platform is committed to not selling, renting, or sharing personal data with any third party except in the following cases:",
        "With the user's explicit consent.",
        "With competent governmental or judicial authorities when there are statutory requirements or binding orders.",
        "With partner entities and service providers, including:",
        "Banks and financing entities.",
        "Verification and documentation companies.",
        "Technical service and hosting providers.",
        "Agents or developers associated with the requested service.",
        "And only to the extent necessary to achieve the service-related purpose.",
        "Data Protection and Information Security:",
        "The Platform commits to appropriate technical and organizational measures to protect personal data, including – by way of example and not limitation – the following:",
        "Using encryption and electronic protection technologies.",
        "Restricting data access to authorized personnel only.",
        "Protecting systems from unauthorized access.",
        "Monitoring suspicious activities and intrusion attempts.",
        "Maintaining data within secure technical environments.",
        "Applying appropriate cybersecurity controls for the nature of the activity.",
        "The Platform also seeks to host data within the Kingdom of Saudi Arabia whenever this is a statutory or operational requirement.",
        "Cookies:",
        "The Platform may use cookies and similar technologies for the purpose of:",
        "Improving the user experience.",
        "Analyzing performance and usage.",
        "Customizing content and services.",
        "Saving user preferences.",
        "The user may control cookie settings through their browser settings.",
        "User Rights:",
        "The user enjoys the following rights in accordance with applicable regulations:",
        "The right to know how their data is collected and used.",
        "The right to access their personal data.",
        "The right to request correction or update of data.",
        "The right to request data deletion where legally possible.",
        "The right to withdraw consent for data processing.",
        "The right to object to certain types of processing as permitted by regulations.",
        "Data Retention:",
        "The Platform retains personal data for the period necessary to achieve the purposes for which it was collected, or for the period required by the regulations and instructions in force in the Kingdom of Saudi Arabia.",
        "Some data may be retained for additional periods for purposes of:",
        "Regulatory compliance.",
        "Protecting rights.",
        "Resolving disputes.",
        "Combating fraud.",
        "Keeping statutory and financial records.",
        "Data Transfer:",
        "The Platform may transfer or share data inside or outside the Kingdom of Saudi Arabia in accordance with the regulations and instructions governing the transfer of personal data, and in a manner that achieves an appropriate level of protection and confidentiality.",
        "Limitation of Liability:",
        "The Platform makes reasonable efforts to protect personal data but does not guarantee the absence of any breaches or cyberattacks beyond reasonable control.",
        "The Platform also bears no responsibility for data disclosure resulting from:",
        "The user's use of insecure means.",
        "Sharing login data with others.",
        "Negligence or misuse by the user.",
        "Failures or breaches beyond the Platform's reasonable control.",
        "Privacy of Minors:",
        "The Platform's services do not target minors below the statutory age, and the Platform must be used by persons with full legal capacity.",
        "Amendments to the Policy:",
        "The Platform reserves the right to amend or update the Privacy Policy at any time in accordance with:",
        "Statutory requirements.",
        "Technical developments.",
        "Service improvements.",
        "Users will be notified of any material updates via the Platform, email, or electronic notifications.",
        "Relationship with Terms and Conditions:",
        "This Privacy Policy is an integral part of the general Terms and Conditions of SNA Real Estate Platform.",
        "Governing Law and Jurisdiction:",
        "This Policy is subject to the laws of the Kingdom of Saudi Arabia, and Saudi courts have jurisdiction over any dispute arising in connection with it, with the possibility of resorting to alternative dispute resolution methods as agreed.",
      ],
    },
    {
      title: "Third: Intellectual Property Policy",
      content: [
        "SNA Real Estate Platform is committed to protecting all intellectual property rights related to the Platform, its contents, services, and technologies, in accordance with the regulations and rules in force in the Kingdom of Saudi Arabia and relevant international agreements.",
        "Using the Platform constitutes an explicit consent from the user to comply with all provisions stated in this Policy.",
        "Platform Ownership and Contents:",
        "All rights related to SNA Real Estate Platform are exclusively reserved and owned by Masar Al-Amjad Company, including – by way of example and not limitation – the following:",
        "The Platform name and trademark (SNA Real Estate).",
        "The logo and visual identity.",
        "User interface design and user experience.",
        "Software, source codes, and databases.",
        "Texts and marketing content.",
        "Designs, graphics, and infographics.",
        "Images, videos, and promotional clips.",
        "Real estate reports, analytics, and indicators.",
        "3D models and displays.",
        "Any future technical developments or updates.",
        "Using, copying, imitating, or reproducing any part of these elements without prior written consent from Masar Al-Amjad Company is prohibited.",
        "User Content:",
        "The user retains ownership of the content they upload or publish through the Platform, including:",
        "Property images.",
        "Videos.",
        "Property descriptions.",
        "Layouts.",
        "Files and documents.",
        "The user grants SNA Real Estate Platform a non-exclusive license to use, display, publish, and market that content within the Platform and its associated channels, for the purpose of providing services, improving user experience, and marketing properties and related services.",
        "The user acknowledges that they own all legal rights to the content they upload or publish and bear full responsibility for any infringement of third-party rights.",
        "Prohibited Uses:",
        "Any user or third party is prohibited from carrying out any of the following actions:",
        "Copying or republishing Platform content without permission.",
        "Using the trademark or logo without authorization.",
        "Data Scraping.",
        "Using automated software or bots to collect data or content.",
        "Reusing content for commercial purposes without consent.",
        "Retraining or developing AI models based on Platform data or content without prior written consent.",
        "Capturing or redistributing content in a manner that infringes intellectual property rights.",
        "Imitating the Platform's design, services, or visual identity in a misleading manner.",
        "3D Models and Displays Rights:",
        "All 3D models, displays, and digital designs produced, developed, or displayed through SNA Real Estate Platform are content protected under intellectual property regulations.",
        "They may not be copied, downloaded, reused, modified, or resold without prior written consent from the Platform and the content owner – where applicable.",
        "Reports, Data, and Analytics:",
        "All real estate reports, analytics, market indicators, and statistical data issued by the Platform are intellectual property belonging to SNA Real Estate Platform.",
        "They may not be republished, used commercially, or attributed to any other party without prior written permission.",
        "Intellectual Property Infringement Reporting:",
        "If any person or entity believes that content published on the Platform infringes their intellectual property rights, they may submit a formal notice including:",
        "The reporter's details.",
        "Description of the infringed right.",
        "Link or description of the objected content.",
        "Proof of ownership of the right.",
        "The Platform may take whatever action it deems appropriate, including removing the content temporarily or permanently until the report is verified.",
        "Liability and Compensation:",
        "The user bears full legal responsibility for any content or materials they publish through the Platform that infringe third-party intellectual property rights, and commits to compensating the Platform for any claims, damages, losses, or legal expenses arising as a result.",
        "Amendments and Updates:",
        "SNA Real Estate Platform reserves the right to amend or update this Policy at any time in accordance with regulatory, technical, or operational developments, and users are notified of updates via the Platform, email, or electronic notifications.",
        "Relationship with Terms and Conditions:",
        "This Intellectual Property Policy is an integral part of the general Terms and Conditions of SNA Real Estate Platform.",
        "Governing Law and Jurisdiction:",
        "This Policy is subject to the laws of the Kingdom of Saudi Arabia, and Saudi courts have jurisdiction over any dispute arising in connection with it, with the possibility of resorting to mediation or arbitration as agreed.",
      ],
    },
    {
      title: "Fourth: Fees and Commissions Policy",
      main: "This Policy defines the fees, commissions, payment mechanisms, and refund procedures related to services provided through SNA Real Estate Platform. Using any paid service through the Platform constitutes an explicit and binding consent to all provisions of this Policy, which is an integral part of the general Terms and Conditions of the Platform.",
      sections: [
        {
          subtitle: "General Provisions",
          items: [
            "All fees and commissions stated in this Policy are calculated in Saudi Riyals and include 15% VAT unless otherwise stated.",
            "The Platform reserves the right to modify fees, commissions, or packages in the future according to market changes or operational requirements, with appropriate advance notice to users before applying any amendment.",
            "All fees are paid through the approved electronic payment gateways within the Platform.",
            "No external transfers or payments are accepted except after the Platform's written approval.",
            "The Platform issues electronic invoices compliant with ZATCA requirements.",
            "The user commits to paying any due fees or commissions within the specified periods.",
            "In case of late payment, the Platform may suspend certain services or accounts until payment is made.",
          ],
        },
        {
          subtitle: "Account and Verification Fees",
          items: [
            "Basic Account: Free for all categories (buyers, sellers, tenants, real estate brokers, real estate developers, banks and financing entities).",
            "Professional Verification and Verified Accounts: SAR 99 one-time payment per account.",
            "The verified account is granted: a 'Verified' badge, display priority, and enhanced credibility within the Platform.",
          ],
        },
        {
          subtitle: "Real Estate Brokers and Users Fees",
          items: [
            "Property Listing — First two properties: Free.",
            "Property Listing — From the third property onwards: SAR 50 per property.",
            "Featured Ads — 7 days: SAR 80.",
            "Featured Ads — 15 days: SAR 150.",
            "Featured Ads — 30 days: SAR 250.",
            "Premium Membership for brokers: SAR 499/month.",
            "Premium Membership includes: display priority, verified badge, performance reports and analytics, account highlighting in search results.",
            "Deal Completion Commission: 0.5% of the deal value, deducted electronically upon completing the sale or lease through the Platform's payment gateway.",
          ],
        },
        {
          subtitle: "Real Estate Developers Fees",
          items: [
            "Project Registration: SAR 2,000 per project (one-time).",
            "Unit Listing: First 20 units included in the project fee, then SAR 20 per additional unit.",
            "Bronze Package: SAR 5,000 for 3 months — includes homepage listing.",
            "Silver Package: SAR 10,000 for 3 months — includes featured listing, email campaigns, notifications to interested users.",
            "Gold Package: SAR 20,000 for 6 months — includes targeted advertising campaigns, performance reports, extended featuring within the Platform.",
            "Sales Commission: 0.25% of the sale value, deducted electronically upon completion of the operation.",
          ],
        },
        {
          subtitle: "Banks and Financing Entities Fees",
          items: [
            "Registration and Technical Integration (API): SAR 15,000 one-time payment.",
            "Annual Subscription: SAR 25,000 per year.",
            "Qualified Client Referral Fee: SAR 200 per qualified financing application.",
            "A qualified application is one that meets: basic data, mobile number verification, and the minimum initial assessment requirements.",
            "Financing Success Commission: 0.5% of the approved financing value in accordance with the concluded partnership agreement.",
          ],
        },
        {
          subtitle: "3D Display Services Fees",
          items: [
            "Uploading a ready 3D display or video: Free for 30 days, then SAR 20 per month per display after the free period ends.",
            "Display created by the Platform — Apartment or small villa (under 300 sqm): SAR 800.",
            "Display created by the Platform — Large villa or palace (300 to 600 sqm): SAR 1,200.",
            "Display created by the Platform — Commercial property or integrated project (over 600 sqm): SAR 1,500.",
            "Monthly Subscription: SAR 2,000 and includes 5 properties.",
            "Quarterly Subscription: SAR 5,500 and includes 15 properties.",
            "Annual Subscription: SAR 18,000 and includes 50 properties.",
            "Additional Success Rate: 0.5% of the deal value when a sale or lease is completed for a property with a Platform-produced 3D display.",
          ],
        },
        {
          subtitle: "Cancellation and Refund Policy",
          items: [
            "Advertisements: Can be canceled within 24 hours with a 50% refund of the fees, after which no refund is given.",
            "Monthly and Annual Subscriptions: Non-refundable after activation.",
            "3D Services: The user is entitled to a full refund if canceled at least 7 days before filming begins.",
            "Banking Integration and API Fees: Non-refundable after activation.",
          ],
        },
        {
          subtitle: "Penalties and Late Payment",
          items: [
            "In case of late payment of due fees, the Platform charges a late fee of 2% per month on the outstanding amount, with a maximum not exceeding the principal outstanding amount.",
            "This is applied in compliance with the regulations in force in the Kingdom of Saudi Arabia.",
          ],
        },
        {
          subtitle: "Financial Settlement",
          items: [
            "The Platform's financial dues are settled weekly or as agreed.",
            "The Platform may withhold or suspend any amounts related to disputes or fraud suspicions until verification is complete.",
          ],
        },
        {
          subtitle: "Relationship, Amendments, and Jurisdiction",
          items: [
            "This Fees and Commissions Policy is an integral part of the general policies and terms of SNA Real Estate Platform.",
            "The Platform reserves the right to amend or update this Policy in the future in accordance with operational developments, statutory requirements, and market conditions, with appropriate advance notice to users before applying them.",
            "This Policy is subject to the laws of the Kingdom of Saudi Arabia, and Saudi courts have jurisdiction over any dispute arising from it.",
          ],
        },
      ],
    },
    {
      title: "Fifth: Real Estate Agents Agreement",
      content: [
        "This Agreement governs the relationship between SNA Real Estate Platform and licensed real estate agents and brokers wishing to use the Platform to market and list properties and communicate with clients.",
        "Registering as an agent or using the Platform constitutes an explicit, final, and binding consent to all provisions of this Agreement, which is an integral part of the general policies and terms of the Platform.",
        "Eligibility and Registration:",
        "The real estate agent must be legally licensed and hold the necessary licenses to practice real estate activity within the Kingdom of Saudi Arabia, and committed to the requirements of the General Authority for Real Estate.",
        "The agent commits to providing:",
        "A copy of the National ID or Residency.",
        "Commercial registration (if applicable).",
        "FAL license or any required licenses.",
        "Official contact information.",
        "Any additional documents requested by the Platform.",
        "The Platform may conduct electronic or manual verification processes to ensure the accuracy of the information and documents provided.",
        "The Platform may grant the account the status of: verified, under verification, or unverified, according to the verification results.",
        "Agent's Obligations:",
        "The real estate agent commits to the following:",
        "Providing accurate, precise, and up-to-date information and advertisements.",
        "Not publishing any misleading or illegal advertisement.",
        "Complying with all applicable real estate regulations and instructions.",
        "Maintaining the confidentiality of client data and not misusing it.",
        "Not using the Platform for any fraudulent or unlawful activities.",
        "Adhering to professional ethics and applicable professional standards.",
        "Immediately updating the status of sold, leased, or unavailable properties.",
        "Property Listing Requirements:",
        "Each property advertisement must include – where applicable – the following:",
        "An accurate property description.",
        "Geographic location.",
        "Area.",
        "Price.",
        "Photos or videos.",
        "Property status.",
        "License or authorization data.",
        "Any material information affecting the client's decision.",
        "The agent acknowledges having the legal right to advertise the property and attaches proof of that.",
        "If the agent does not own the property: a legal power of attorney, authorization, or permit allowing advertising and marketing must exist.",
        "It is not permitted to conceal any material defects, obligations, or disputes related to the property.",
        "Documentation and Verification:",
        "The Platform provides verification and documentation services for accounts and advertisements.",
        "Some data may be linked to governmental authorities or approved verification systems where statutorily or technically available.",
        "The Platform may suspend or remove any advertisement until verification procedures are completed.",
        "Communication and Dealings:",
        "Communication between parties takes place through the means available within the Platform or via approved communication channels.",
        "The Platform bears no responsibility for agreements or contracts concluded between parties outside the scope of its technical services.",
        "The agent commits to dealing professionally and transparently with clients.",
        "The Platform may retain records of correspondence or operations for regulatory, legal, or operational purposes.",
        "Fees and Commissions:",
        "The agent commits to paying the due fees and commissions in accordance with the approved Fees and Commissions Policy.",
        "Fees may include:",
        "Advertisement fees.",
        "Professional memberships.",
        "Documentation services.",
        "Marketing campaigns.",
        "Deal commissions.",
        "The Platform reserves the right to suspend certain services upon late payment.",
        "Advertisements and Prohibited Content:",
        "The agent is prohibited from publishing or sharing any of the following content:",
        "Fake advertisements.",
        "Unauthorized properties.",
        "Misleading data or images.",
        "Content contrary to regulations or public morals.",
        "Any content that infringes third-party rights or intellectual property rights.",
        "The Platform may remove any violating content without prior notice.",
        "Intellectual Property and Data:",
        "The agent acknowledges that all rights related to the Platform and its contents are owned by Masar Al-Amjad Company.",
        "The Platform's data or content may not be copied or reused without prior written consent.",
        "The agent commits to not using technical tools or automated software to scrape data or copy content.",
        "Liability and Compensation:",
        "The agent bears full legal responsibility for:",
        "The accuracy of advertisements.",
        "The documents provided.",
        "The published data.",
        "Any obligations or claims arising from their use of the Platform.",
        "The agent commits to compensating the Platform for any damages, losses, lawsuits, or claims resulting from:",
        "Violating regulations.",
        "Providing misleading data.",
        "Infringing third-party rights.",
        "Misusing the Platform.",
        "Suspension and Termination:",
        "The Platform may suspend, stop, or terminate the agent's account in the following cases:",
        "Violation of this Agreement.",
        "Providing incorrect information.",
        "Suspicion of fraudulent activity.",
        "Abuse of clients or the Platform.",
        "Violation of regulations and regulatory instructions.",
        "This entails no liability on the Platform towards the agent.",
        "Limitation of Platform's Liability:",
        "The Platform acts as a technical intermediary and bears no responsibility for:",
        "Completing deals.",
        "The validity of contracts between parties.",
        "Real estate disputes.",
        "Failed or canceled deals.",
        "The Platform does not guarantee achieving any sales or specific marketing results.",
        "Force Majeure:",
        "Neither the Platform nor the agent bears responsibility for any delay or failure resulting from circumstances beyond control, including:",
        "Natural disasters.",
        "Technical failures.",
        "Cyberattacks.",
        "Governmental decisions.",
        "Communication service outages.",
        "Relationship with Policies and Terms:",
        "This Agreement is an integral part of the general policies and terms of SNA Real Estate Platform.",
        "Amendments and Updates:",
        "The Platform reserves the right to amend or update this Agreement at any time in accordance with operational developments, regulations and instructions, and market requirements, and agents will be notified of amendments via the Platform, email, or electronic notifications.",
        "Governing Law and Jurisdiction:",
        "This Agreement is subject to the laws of the Kingdom of Saudi Arabia, and Saudi courts have jurisdiction over any dispute arising from it, with the possibility of resorting to mediation or arbitration as agreed between the parties.",
      ],
    },
    {
      title: "Sixth: Real Estate Developers Agreement",
      content: [
        "This Agreement governs the relationship between SNA Real Estate Platform and real estate developers wishing to use the Platform to market, manage, and display their real estate projects within the Kingdom of Saudi Arabia.",
        "Registering as a developer or using any of the Platform's services constitutes an explicit, final, and binding consent to all provisions of this Agreement, which is an integral part of the general Terms and Conditions of the Platform.",
        "Eligibility and Registration:",
        "The real estate developer must be:",
        "Legally licensed.",
        "Holding a valid commercial registration.",
        "Legally authorized to practice real estate and development activities within the Kingdom of Saudi Arabia.",
        "The developer commits to providing the required documents and data, including – by way of example and not limitation:",
        "Commercial registration.",
        "Legal licenses.",
        "Project data.",
        "Authorized representative data.",
        "Ownership, development, or contracting documents.",
        "Any additional documents requested by the Platform.",
        "The Platform may verify the accuracy of data and documents before activating the developer's account or project.",
        "The Platform may reject or suspend any project or account that does not meet verification or compliance requirements.",
        "Developer's Obligations:",
        "The real estate developer commits to the following:",
        "Providing accurate, precise, and up-to-date information about projects and real estate units.",
        "Complying with the regulations and instructions in force within the Kingdom of Saudi Arabia.",
        "Fully disclosing: project status, licenses, implementation phases, material risks, and any changes affecting the project.",
        "Continuously updating the status of units and projects.",
        "Not publishing any misleading or exaggerated information.",
        "Adhering to standards of transparency and professionalism in dealing with clients.",
        "Project Display Requirements:",
        "Each project or advertisement must include – where applicable – the following:",
        "Project description.",
        "Location.",
        "Prices.",
        "Areas.",
        "Layouts.",
        "Implementation phases.",
        "Expected delivery date.",
        "Project images or models.",
        "Fees and shared services.",
        "Warranty and maintenance data.",
        "The developer commits to disclosing any: mortgages, disputes, regulatory restrictions, expected delays, or material modifications to the project.",
        "In off-plan sales projects: the developer commits to complying with the relevant regulations and instructions, and disclosing the contracting, payment, and delivery terms.",
        "Marketing and Display Services:",
        "The Platform provides marketing and highlighting services for real estate projects in accordance with the approved packages.",
        "The developer may benefit from:",
        "Advertising campaigns.",
        "Project highlighting.",
        "Analytical reports.",
        "3D services.",
        "Digital marketing campaigns.",
        "The Platform does not guarantee achieving specific results or sales.",
        "3D Display Services:",
        "The developer may request 3D display or professional video services through the Platform.",
        "These services are subject to the fees and conditions specified in the Fees and Commissions Policy and the 3D Services Terms.",
        "The developer commits to providing accurate and correct data to produce the digital models and displays.",
        "The Platform bears no responsibility for any discrepancies resulting from incorrect information or layouts provided by the developer.",
        "Payments, Fees, and Commissions:",
        "The developer commits to paying all due fees and commissions in accordance with the approved Fees and Commissions Policy.",
        "Fees may include:",
        "Project registration fees.",
        "Real estate unit fees.",
        "Marketing fees.",
        "Digital service fees.",
        "Sales commissions.",
        "In case of completed sales through the Platform: the Platform is entitled to the commission specified in the approved Policy.",
        "The Platform may suspend certain services in case of late payment.",
        "Warranties and Delivery:",
        "The developer commits to clearly specifying expected delivery dates.",
        "The developer bears full responsibility for:",
        "Project execution.",
        "Work quality.",
        "Compliance with specifications.",
        "Maintenance work and warranties.",
        "The Platform bears no responsibility for:",
        "Delivery delays.",
        "Project failures.",
        "Construction defects.",
        "Contractual disputes between the developer and clients.",
        "Intellectual Property and Content:",
        "The developer retains ownership of the content related to their projects.",
        "The developer grants the Platform a license to use, display, and market the content and projects through the Platform and its associated channels.",
        "The developer may not use, copy, or re-exploit any content or data belonging to the Platform without prior written consent.",
        "Liability and Compensation:",
        "The developer bears full legal responsibility for:",
        "The accuracy of data.",
        "The accuracy of advertisements.",
        "Licenses.",
        "Financial and technical information.",
        "Any obligations towards clients or regulatory authorities.",
        "The developer commits to compensating the Platform for any losses, claims, damages, or lawsuits resulting from:",
        "Providing incorrect data.",
        "Violating regulations.",
        "Infringing third-party rights.",
        "Breaching their contractual obligations.",
        "Limitation of Platform's Liability:",
        "The Platform acts as a technical and marketing intermediary and bears no responsibility for:",
        "Project execution.",
        "The developer's obligations.",
        "Contractual disputes.",
        "Investment or sales results.",
        "Information or reports published through the Platform are not an investment recommendation or a guarantee of future returns.",
        "Cybersecurity and Data Protection:",
        "The Platform commits to taking appropriate technical measures to protect systems and data.",
        "The developer commits to not:",
        "Attempting to hack systems.",
        "Using tools to scrape data.",
        "Misusing information or client data.",
        "Data and processing policies are subject to the approved Privacy Policy.",
        "Suspension and Termination:",
        "The Platform may suspend, stop, or delete the developer's account or any project in the following cases:",
        "Violating regulations.",
        "Providing misleading information.",
        "Presence of fraud suspicions.",
        "Harming the Platform or users.",
        "Violating this Agreement or its associated policies.",
        "Force Majeure:",
        "No party bears responsibility for any delay or failure resulting from circumstances beyond control, including:",
        "Natural disasters.",
        "Technical failures.",
        "Cyberattacks.",
        "Governmental decisions.",
        "Communication service outages.",
        "Relationship with Terms and Conditions:",
        "This Agreement is an integral part of the general policies and terms of SNA Real Estate Platform.",
        "Amendments and Updates:",
        "The Platform reserves the right to amend or update this Agreement in the future in accordance with operational developments, regulations and instructions, and market requirements, and developers will be notified of amendments via the Platform, email, or electronic notifications.",
        "Governing Law and Jurisdiction:",
        "This Agreement is subject to the laws of the Kingdom of Saudi Arabia, and Saudi courts have jurisdiction over any dispute arising from it, with the possibility of resorting to mediation or arbitration as agreed between the parties.",
      ],
    },
    {
      title: "Seventh: Banks and Financing Entities Agreement",
      content: [
        "This Agreement governs the relationship between SNA Real Estate Platform and banks and financing entities wishing to offer, provide, or market real estate financing programs or receive financing applications through the Platform.",
        "The financing entity's use of the Platform's services or technical integration constitutes an explicit, final, and binding consent to all provisions of this Agreement, which is an integral part of the general policies and terms of SNA Real Estate Platform.",
        "Eligibility and Registration:",
        "The financing entity must be:",
        "Legally licensed.",
        "Subject to the competent regulatory authorities within the Kingdom of Saudi Arabia.",
        "Authorized to provide real estate financing services or related financing products.",
        "The financing entity commits to providing:",
        "The legal license.",
        "Official contact information.",
        "Authorized representative data.",
        "The technical information required for integration.",
        "Any additional documents requested by the Platform.",
        "The Platform may conduct verification or review of data and documents before activating the service or integration.",
        "Scope of Services:",
        "The Platform enables financing entities – as agreed – to access the following services:",
        "Displaying financing products.",
        "Receiving financing applications.",
        "Technical integration via APIs.",
        "Referral services.",
        "Joint marketing campaigns.",
        "Analysis and reporting services.",
        "The Platform is not obligated to grant any financing entity exclusivity unless otherwise agreed in writing.",
        "Data Sharing and Privacy:",
        "User data is not shared with the financing entity except after obtaining explicit consent from the user.",
        "Shared data may include – when the user agrees – the following:",
        "Name.",
        "Mobile number.",
        "Email address.",
        "Required financing amount.",
        "Approximate income data.",
        "Initial eligibility data.",
        "The financing entity commits to the following:",
        "Protecting personal data.",
        "Not using data for purposes other than those specified.",
        "Complying with the Personal Data Protection Law and related regulations.",
        "Not sharing data with any unauthorized party.",
        "The Platform's Privacy Policy is an integral part of this Agreement.",
        "Financing Offers and Disclosure:",
        "The financing entity commits to providing accurate, precise, and up-to-date information about financing products.",
        "Financing offers must include – where applicable – the following:",
        "Annual financing rate or cost.",
        "Financing period.",
        "Administrative fees.",
        "Eligibility conditions.",
        "Required guarantees.",
        "Any additional fees or obligations.",
        "Publishing any misleading, inaccurate, or regulation-violating offers is prohibited.",
        "The Platform may remove or suspend any violating offer without prior notice.",
        "Preliminary Approval and Technical Integration:",
        "The financing entity may provide preliminary approval or initial assessment services through the Platform or via technical integration.",
        "Preliminary approval is considered an initial indicator only and does not represent final financing approval.",
        "The Platform bears no responsibility for:",
        "Credit rejection or acceptance decisions.",
        "Creditworthiness assessment.",
        "Final financing contracts.",
        "The technical aspects of integration are determined according to the technical agreements between the two parties.",
        "Fees and Commissions:",
        "Services provided to financing entities are subject to the fees and commissions specified in the Platform's Fees and Commissions Policy.",
        "Fees may include:",
        "Registration fees.",
        "Technical integration fees.",
        "Annual subscriptions.",
        "Referral fees.",
        "Successful financing commissions.",
        "Marketing campaigns.",
        "Some additional fees or commissions are determined according to the partnership agreements concluded between the two parties.",
        "Compliance and Statutory Obligations:",
        "The financing entity commits to all regulations and instructions in force within the Kingdom of Saudi Arabia.",
        "The financing entity bears full responsibility for:",
        "Regulatory compliance.",
        "Credit verification.",
        "The validity of financing contracts.",
        "Its own financial and regulatory obligations.",
        "The Platform may suspend or stop data sharing or services in case of suspicion of any: fraud, regulatory violation, security breach, or misuse.",
        "Cybersecurity and Systems Protection:",
        "Both parties commit to taking appropriate technical and organizational measures to protect systems and data.",
        "The financing entity is not permitted to:",
        "Attempt to hack systems.",
        "Use tools to scrape data.",
        "Misuse technical integration interfaces.",
        "Share access data with unauthorized parties.",
        "The Platform may stop integration or restrict access in case of security or technical risks.",
        "Intellectual Property:",
        "SNA Real Estate Platform retains all intellectual property rights related to the Platform, its technologies, and its contents.",
        "The financing entity is not permitted to use:",
        "The Platform name.",
        "The logo.",
        "The visual identity.",
        "The content or data.",
        "Except as permitted by the Platform or the concluded partnership agreements.",
        "Limitation of Liability:",
        "The Platform acts as a technical intermediary and bears no responsibility for:",
        "Financing decisions.",
        "Financing contracts.",
        "Credit assessments.",
        "Any financial or investment losses.",
        "The Platform does not guarantee: acceptance of financing applications, client results or numbers, or achieving any returns or specific marketing results.",
        "Liability and Compensation:",
        "The financing entity bears full legal responsibility for:",
        "Financing products.",
        "Published data.",
        "Regulatory compliance.",
        "Any violations or legal claims related to its services.",
        "The financing entity commits to compensating the Platform for any losses, claims, or lawsuits resulting from:",
        "Violating regulations.",
        "Misusing data.",
        "Providing misleading information.",
        "Breaching this Agreement.",
        "Suspension and Termination:",
        "The Platform may suspend, stop, or terminate the financing entity's services in the following cases:",
        "Violation of regulations or instructions.",
        "Presence of fraud or breach suspicions.",
        "Providing misleading information.",
        "Harming users or the Platform.",
        "Violating this Agreement or its associated policies.",
        "Force Majeure:",
        "No party bears responsibility for any delay or failure resulting from circumstances beyond control, including:",
        "Natural disasters.",
        "Technical failures.",
        "Cyberattacks.",
        "Governmental decisions.",
        "Communication service outages.",
        "Relationship with Terms and Conditions:",
        "This Agreement is an integral part of the general policies and terms of SNA Real Estate Platform.",
        "Amendments and Updates:",
        "The Platform reserves the right to amend or update this Agreement in accordance with operational developments, statutory requirements, and technical and regulatory developments, and financing entities will be notified of updates via the approved official means.",
        "Governing Law and Jurisdiction:",
        "This Agreement is subject to the laws of the Kingdom of Saudi Arabia, and Saudi courts have jurisdiction over any dispute arising from it, with the possibility of resorting to mediation or arbitration as agreed between the parties.",
      ],
    },
    {
      title: "Eighth: 3D Display Services Terms and Conditions",
      content: [
        "This Agreement governs the use of 3D display services and professional videos provided through SNA Real Estate Platform, and clarifies the rights, obligations, and responsibilities related to users, owners, agents, and real estate developers benefiting from this service.",
        "Requesting or using the service constitutes an explicit, final, and binding consent to all provisions of this Agreement, which is an integral part of the general Terms and Conditions of SNA Real Estate Platform.",
        "Service Nature:",
        "The Platform provides 3D display services and professional videos for properties with the aim of:",
        "Improving the user experience.",
        "Enhancing real estate marketing quality.",
        "Facilitating interactive property viewing.",
        "Supporting users' preliminary decision-making.",
        "The service includes – depending on the type of request – the following:",
        "Uploading ready 3D displays.",
        "Creating professional 3D models.",
        "Filming professional property videos.",
        "Virtual tours.",
        "Integrating displays within property and project pages.",
        "This service is not a substitute for actual property inspection or engineering or legal examination.",
        "Service Usage Conditions:",
        "The user, owner, developer, or agent commits to providing:",
        "Accurate and precise information.",
        "Legitimate photos and layouts.",
        "Data reflecting the actual reality of the property.",
        "The user acknowledges that any incorrect information, layouts, or photos may lead to:",
        "Service suspension.",
        "Display removal.",
        "Full legal liability being placed on them.",
        "The Platform may reject or suspend any service request that does not comply with:",
        "Regulations.",
        "Internal policies.",
        "Technical or professional standards.",
        "Platform's Responsibility:",
        "The Platform provides the service according to the technical and professional standards available at the time of execution.",
        "The Platform is not liable for:",
        "Any minor differences between the digital display and the actual property.",
        "Purchase or investment decisions based on the service.",
        "Non-apparent or undisclosed defects.",
        "Any incorrect information provided by the user, developer, or agent.",
        "3D displays or videos are not considered:",
        "Engineering reports.",
        "Quality guarantees.",
        "Legal property documentation.",
        "Responsibility of the User, Developer, and Agent:",
        "The requester bears full responsibility for:",
        "The accuracy of data.",
        "The legality of the property.",
        "The permits and approvals required for filming or display.",
        "The user commits to not:",
        "Using the service in a misleading manner.",
        "Modifying content in a way that distorts the truth.",
        "Using the service in violation of regulations or third-party rights.",
        "The user acknowledges that the Platform is not responsible for any contractual or financial obligations arising from using the service.",
        "Fees and Subscriptions:",
        "3D and video services are subject to the fees and subscriptions specified in the Platform's Fees and Commissions Policy.",
        "Fees include – depending on the type of service – the following:",
        "Filming and production fees.",
        "Subscription fees.",
        "Promotion and display fees.",
        "Virtual tour fees.",
        "Publishing continuity fees.",
        "Fees are clarified to the user before executing the service and approving it electronically.",
        "Additional Success Rate:",
        "If a sale or lease is completed for a property for which a 3D display or professional video was produced by the Platform: the Platform is entitled to the rate specified in the Fees and Commissions Policy.",
        "The user agrees to the calculation of this rate upon completion of the deal according to the Platform's records or associated systems.",
        "Intellectual Property Rights:",
        "All that is executed by the Platform, including the following:",
        "Designs.",
        "3D models.",
        "Videos.",
        "Visual processing.",
        "Digital effects.",
        "Design and production files.",
        "Are considered protected intellectual property rights in favor of SNA Real Estate Platform and Masar Al-Amjad Company unless otherwise agreed in writing.",
        "It is not permitted to:",
        "Copy the content.",
        "Resell it.",
        "Reuse it.",
        "Modify it.",
        "Publish it outside the Platform.",
        "Except with prior written consent.",
        "Display and Publishing Period:",
        "Content is displayed for a specified period according to the chosen package or subscription.",
        "The Platform may remove or stop any display:",
        "After the subscription ends.",
        "Upon violating regulations.",
        "When there are material disputes or complaints.",
        "Upon non-payment of due fees.",
        "Cancellation and Refund:",
        "The user may request service cancellation before execution begins in accordance with the approved refund policy.",
        "The user may not request cancellation after the Platform has begun:",
        "Filming.",
        "Design.",
        "Production.",
        "Technical processing.",
        "No refund may be claimed except as determined by the Platform or applicable regulations.",
        "All cancellation and refund requests are subject to the Platform's Fees and Commissions Policy.",
        "Cybersecurity and Data Protection:",
        "The Platform commits to taking appropriate technical measures to protect:",
        "Files.",
        "Designs.",
        "Data.",
        "Digital materials.",
        "The user is not permitted to:",
        "Attempt to hack systems.",
        "Scrape technical files.",
        "Misuse the content or digital services.",
        "Limitation of Liability:",
        "The Platform bears no responsibility for:",
        "Sale or lease results.",
        "The market value of the property.",
        "The accuracy of financial valuations.",
        "Investment or financing decisions.",
        "The responsibility for final verification, inspection, and examination remains with the user, buyer, or investor.",
        "Suspension and Termination:",
        "The Platform may suspend or remove any display or service in the following cases:",
        "Violating regulations.",
        "Misusing the service.",
        "Providing misleading data.",
        "Infringing intellectual property rights.",
        "Non-payment of due fees.",
        "Force Majeure:",
        "No party bears responsibility for any delay or failure resulting from circumstances beyond control, including:",
        "Natural disasters.",
        "Technical failures.",
        "Cyberattacks.",
        "Governmental decisions.",
        "Communication service outages.",
        "Relationship with Policies and Terms:",
        "This Agreement is an integral part of the general Terms and Conditions of SNA Real Estate Platform.",
        "Amendments and Updates:",
        "The Platform reserves the right to amend or update this Agreement in accordance with technical developments, operational requirements, and regulations and instructions, and users will be notified of updates via the approved official means.",
        "Governing Law and Jurisdiction:",
        "This Agreement is subject to the laws of the Kingdom of Saudi Arabia, and Saudi courts have jurisdiction over any dispute arising from it, with the possibility of resorting to mediation or arbitration as agreed between the parties.",
      ],
    },
    {
      title: "Ninth: General Final Provisions",
      content: [
        "These final provisions form an essential and complementary part of all:",
        "Policies and terms.",
        "Agreements.",
        "Regulatory annexes.",
        "Of SNA Real Estate Platform owned by Masar Al-Amjad Company, and apply to all users and Platform services without exception.",
        "Legal Force of Electronic Consent:",
        "The user acknowledges that:",
        "Registering on the Platform.",
        "Using the services.",
        "Clicking the consent button.",
        "Completing electronic operations.",
        "Constitute a legally binding electronic consent to all terms and policies associated with the Platform.",
        "Electronic records, messages, and notifications have legal standing under the regulations in force in the Kingdom of Saudi Arabia.",
        "Official Language:",
        "Arabic is the official and adopted language for interpreting all:",
        "Policies.",
        "Agreements.",
        "Contracts.",
        "Official correspondence.",
        "In case of any conflict between the Arabic version and any other translation: the Arabic version takes precedence.",
        "Severability of Provisions:",
        "If any provision is invalid, any clause is unlawful, or any part is unenforceable, this shall not affect the validity and enforceability of the remaining provisions and clauses.",
        "Waiver and Non-Waiver:",
        "The Platform's non-exercise of any of its rights at any time shall not constitute a waiver of that right.",
        "The user may not assign any of their rights or obligations related to using the Platform without prior written consent from the Platform.",
        "Force Majeure:",
        "No party bears responsibility for any delay or failure resulting from circumstances beyond control, including – by way of example and not limitation:",
        "Natural disasters.",
        "Fires.",
        "Floods.",
        "Wars or disturbances.",
        "Governmental decisions.",
        "Major technical failures.",
        "Communication or internet service outages.",
        "Cyberattacks.",
        "Pandemics or emergency circumstances.",
        "Affected obligations are suspended throughout the duration of the force majeure event, to the extent affected only.",
        "Cybersecurity and Anti-Fraud:",
        "The Platform commits to applying appropriate measures and procedures to protect:",
        "Systems.",
        "Data.",
        "Electronic operations.",
        "The user commits to not:",
        "Attempting to hack systems.",
        "Misusing the Platform.",
        "Using any harmful tools or software.",
        "Circumventing, defrauding, or manipulating data or operations.",
        "The Platform may take all necessary actions, including:",
        "Suspending accounts.",
        "Stopping operations.",
        "Notifying the competent authorities.",
        "Claiming compensation.",
        "Dispute Resolution:",
        "The parties first seek to resolve any dispute amicably within a reasonable period.",
        "It is permitted to resort to:",
        "Mediation.",
        "Arbitration.",
        "The Saudi Center for Commercial Arbitration.",
        "As agreed between the parties, without prejudice to the right to litigate before the competent judicial authorities within the Kingdom of Saudi Arabia.",
        "Jurisdiction and Governing Law:",
        "All policies, agreements, services, and dealings of SNA Real Estate Platform are subject to the laws of the Kingdom of Saudi Arabia.",
        "Saudi courts have jurisdiction to consider and adjudicate any dispute arising from the use of the Platform or its associated services.",
        "Amendments and Updates:",
        "The Platform reserves the right to amend or update the Terms and Conditions, policies, fees, agreements, and services at any time in accordance with statutory requirements, operational developments, technical developments, and market conditions.",
        "Users are notified of updates via:",
        "Email.",
        "In-Platform notifications.",
        "Text messages.",
        "Any electronic means adopted by the Platform.",
        "Continued use of the Platform after an update constitutes acceptance of the amended version.",
        "Relationship Between Legal Documents:",
        "The following documents are interconnected and integrated parts that together form the complete legal framework of SNA Real Estate Platform:",
        "Policies and terms.",
        "Privacy Policy.",
        "Intellectual Property Policy.",
        "Fees and Commissions Policy.",
        "Real Estate Agents Agreement.",
        "Real Estate Developers Agreement.",
        "Banks and Financing Entities Agreement.",
        "3D Display Services Terms.",
        "Any additional policies or annexes the Platform adopts in the future.",
        "Platform Rights:",
        "SNA Real Estate Platform retains all rights related to the following:",
        "Operating and managing the Platform.",
        "Developing services.",
        "Modifying or stopping services.",
        "Protecting data and systems.",
        "Protecting intellectual property.",
        "Protecting the reputation of the Platform and its users.",
        "Taking the necessary legal actions in case of violations.",
        "Official Communication:",
        "All official notifications and correspondence between the Platform and the user shall be through:",
        "The registered email.",
        "In-app notifications.",
        "Text messages.",
        "The official channels approved by the Platform.",
        "Any notification sent via these means produces its legal effects once sent in accordance with the user's registered data.",
        "Effectiveness and Validity of Provisions:",
        "These provisions and policies come into effect from the date of their publication through SNA Real Estate Platform and remain in force until amended or replaced by the Platform in accordance with applicable regulations.",
      ],
    },
    {
      title: "Tenth: Electronic Declaration and Consent",
      content: [
        "Declaration of Consent:",
        "The user declares and agrees, finally and bindingly, that when:",
        "Creating an account on SNA Real Estate Platform.",
        "Using any of the Platform's services.",
        "Clicking the 'Agree', 'Register', or 'Continue' button.",
        "Benefiting from any electronic service or feature within the Platform.",
        "This constitutes an explicit, final, and binding electronic consent to all:",
        "Terms and Conditions.",
        "Policies.",
        "Agreements.",
        "Fees and commissions.",
        "Regulatory annexes.",
        "Of SNA Real Estate Platform.",
        "Declaration of Data Accuracy:",
        "The user declares that all:",
        "Data.",
        "Information.",
        "Documents.",
        "Licenses.",
        "Authorizations.",
        "Provided through the Platform are accurate, precise, and up-to-date, and bears full statutory and legal responsibility for any incorrect, misleading, or forged information.",
        "Declaration of Legal Capacity:",
        "The user declares that they:",
        "Have full legal capacity.",
        "Are legally authorized to use the Platform.",
        "Possess the necessary authorities to enter into the obligations and agreements related to the used services.",
        "If the user represents a legal entity, they declare having the necessary legal powers to act on its behalf and attach proof of that.",
        "Declaration of Understanding Risks:",
        "The user declares that they understand and comprehend that:",
        "The Platform acts as a technical and digital intermediary.",
        "Investment, real estate, or financing decisions remain the user's responsibility.",
        "Information published through the Platform is not a guarantee of returns, prices, or investment results.",
        "Final inspection, examination, and verification are the user's responsibility.",
        "Declaration of Regulatory Compliance:",
        "The user declares their full commitment to all:",
        "Regulations.",
        "Rules.",
        "Instructions.",
        "Regulatory requirements.",
        "In force within the Kingdom of Saudi Arabia related to using the Platform or real estate, financing, or technical activity.",
        "Declaration of Account Protection:",
        "The user declares being the sole responsible party for:",
        "Login data.",
        "Passwords.",
        "Protecting their account.",
        "All operations executed through their account.",
        "And commits to notifying the Platform immediately upon suspecting any unauthorized use.",
        "Declaration of Fees and Commissions:",
        "The user declares that they:",
        "Have reviewed the Fees and Commissions Policy.",
        "Understood all applicable fees.",
        "Agree to pay any fees or commissions due for the services used.",
        "Declaration of Privacy and Data Protection:",
        "The user declares that they:",
        "Have reviewed the Privacy Policy.",
        "Agreed to the collection and processing of their data in accordance with applicable regulations and policies.",
        "Agree to share the necessary data with service-related entities when needed and in accordance with regulations.",
        "Declaration of Intellectual Property:",
        "The user declares that all:",
        "Rights.",
        "Trademarks.",
        "Logos.",
        "Software.",
        "Designs.",
        "Data.",
        "Content.",
        "Of SNA Real Estate Platform are owned by Masar Al-Amjad Company, and commits to not infringing any intellectual property rights associated with the Platform.",
        "Legal Force of Electronic Records:",
        "The user declares that:",
        "Electronic records.",
        "Messages.",
        "Electronic contracts.",
        "Notifications.",
        "Digital consents.",
        "Issued through the Platform constitute legally recognized and binding evidence under the regulations in force in the Kingdom of Saudi Arabia.",
        "Amendments and Updates:",
        "The user acknowledges the Platform's right to:",
        "Modify services.",
        "Update policies.",
        "Modify fees.",
        "Develop systems and features.",
        "In accordance with operational and regulatory requirements, with notification to users via the approved means.",
        "Governing Law:",
        "This declaration and everything related to using SNA Real Estate Platform is subject to the laws of the Kingdom of Saudi Arabia, and Saudi courts have jurisdiction over any dispute arising in connection with it.",
        "Effectiveness:",
        "This declaration is effective and binding from the date of the user's electronic consent or their use of any of SNA Real Estate Platform's services.",
      ],
    },
  ],
};
